{
  "common": {
    "save": "Enregistrer",
    "saving": "Enregistrement...",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "edit": "Modifier",
    "add": "Ajouter",
    "search": "Rechercher...",
    "close": "Fermer",
    "back": "Retour",
    "backToHome": "Retour à l'accueil",
    "download": "Télécharger",
    "downloading": "Téléchargement...",
    "viewAll": "Voir tout →",
    "active": "Actif",
    "inactive": "Inactif",
    "status": "Statut",
    "date": "Date",
    "reference": "Référence",
    "amount": "Montant",
    "actions": "Actions",
    "loading": "Chargement...",
    "error": "Erreur",
    "retry": "Réessayer",
    "noResults": "Aucun résultat",
    "select": "Sélectionner...",
    "allStatuses": "Tous les statuts",
    "all": "Tous",
    "yes": "Oui",
    "no": "Non",
    "viewDetails": "Voir le détail",
    "name": "Nom",
    "email": "Email",
    "phone": "Téléphone",
    "address": "Adresse",
    "city": "Ville",
    "postalCode": "Code postal",
    "siren": "SIREN",
    "erp": "ERP",
    "type": "Type",
    "description": "Description",
    "comment": "Commentaire",
    "other": "Autre",
    "none": "-",
    "filterByErp": "Filtrer par ERP :",
    "users": "Utilisateurs",
    "sendRequest": "Envoyer la demande",
    "sending": "Envoi en cours...",
    "logout": "Déconnexion",
    "client": "Client",
    "exportCsv": "Exporter CSV",
    "importCsv": "Importer CSV",
    "optional": "Optionnel",
    "firstname": "Prénom",
    "lastname": "Nom",
    "password": "Mot de passe",
    "confirm": "Confirmer"
  },
  "nav": {
    "dashboard": "Tableau de bord",
    "invoices": "Factures",
    "orders": "Commandes",
    "shipments": "Livraisons",
    "tickets": "SAV",
    "catalog": "Catalogue",
    "projects": "Projets",
    "proposals": "Devis",
    "gallery": "Documents",
    "revisions": "Révisions",
    "admin": "Administration",
    "erps": "Fournisseurs",
    "suppliers": "Clients",
    "users": "Utilisateurs",
    "logs": "Logs",
    "registrations": "Inscriptions",
    "groups": "Groupes",
    "collapseSidebar": "Réduire le menu",
    "expandSidebar": "Développer le menu",
    "pendingOrders": "Commandes invités",
    "adminProposals": "Devis & Signatures",
    "adminRevisions": "Révisions produits",
    "adminProducts": "Catalogue",
    "adminUsage": "Consommation",
    "adminBilling": "Abonnements",
    "tarifs": "Abonnement",
    "myTeam": "Mon équipe",
    "myPayments": "Mes paiements",
    "mesCredits": "Mes crédits",
    "adminProfile": "Mon profil",
    "erpSettings": "Paramètres ERP",
    "adminMigration": "Migration ERP",
    "sectionConfig": "Configuration générale",
    "adminHelpTooltips": "Bulles d'aide",
    "adminNotificationRules": "Règles de notification",
    "documentSignatures": "Signatures",
    "document_signatures": "Signatures"
  },
  "login": {
    "subtitle": "Connectez-vous à votre espace",
    "email": "Adresse email",
    "emailPlaceholder": "votre@email.com",
    "password": "Mot de passe",
    "submit": "Se connecter",
    "loading": "Connexion...",
    "forgotPassword": "Mot de passe oublié ?",
    "registerRequest": "Demander une inscription",
    "supplierSubtitle": "Connectez-vous à votre espace client",
    "insertPassword": "Insérer votre mot de passe"
  },
  "forgotPassword": {
    "title": "Mot de passe oublié",
    "subtitle": "Entrez votre adresse email pour recevoir un lien de réinitialisation.",
    "email": "Adresse email",
    "submit": "Envoyer le lien",
    "loading": "Envoi...",
    "success": "Un email de réinitialisation a été envoyé si ce compte existe.",
    "backToLogin": "Retour à la connexion"
  },
  "resetPassword": {
    "title": "Nouveau mot de passe",
    "subtitle": "Choisissez un nouveau mot de passe sécurisé.",
    "password": "Nouveau mot de passe",
    "confirm": "Confirmer le mot de passe",
    "submit": "Réinitialiser",
    "loading": "Réinitialisation...",
    "success": "Mot de passe réinitialisé avec succès.",
    "errorMatch": "Les mots de passe ne correspondent pas.",
    "backToLogin": "Retour à la connexion"
  },
  "register": {
    "subtitle": "Demande d'inscription",
    "chooseTypeLabel": "Quel type d'inscription souhaitez-vous effectuer ?",
    "typeSupplier": "Je suis un fournisseur",
    "typeSupplierDesc": "Je souhaite créer mon espace client en tant que fournisseur",
    "typeClient": "Je suis un client",
    "typeClientDesc": "Je souhaite accéder à l'espace client de mon fournisseur",
    "companyName": "Nom de l'entreprise *",
    "siren": "SIREN *",
    "sirenPlaceholder": "ex: 123 456 789",
    "lastname": "Nom *",
    "firstname": "Prénom *",
    "email": "Email *",
    "phone": "Téléphone *",
    "phonePlaceholder": "ex: 06 12 34 56 78",
    "erpType": "Type d'ERP *",
    "selectErp": "-- Sélectionnez --",
    "commentLabel": "Commentaire",
    "erpBrandLabel": "Marque et version de votre ERP *",
    "erpBrandHint": "Veuillez préciser la marque et la version de votre ERP",
    "erpBrandPlaceholder": "ex: SAP Business One 10.0",
    "submit": "Envoyer la demande",
    "loading": "Envoi en cours...",
    "alreadyAccount": "Déjà un compte ? Se connecter",
    "captchaLabel": "Vérification anti-robot *",
    "captchaQuestion": "Combien fait {{a}} + {{b}} ?",
    "captchaPlaceholder": "Votre réponse",
    "captchaError": "Réponse incorrecte, veuillez réessayer",
    "client": {
      "supplierSection": "Informations fournisseur",
      "clientSection": "Vos informations",
      "supplierName": "Nom du fournisseur *",
      "supplierNamePlaceholder": "Rechercher ou saisir le nom du fournisseur...",
      "supplierSiren": "SIREN du fournisseur *",
      "supplierRequired": "Le nom du fournisseur est requis",
      "knownSupplier": "Référencé",
      "supplierNotFound": "Fournisseur non trouvé — saisissez son nom librement",
      "clientSiren": "SIREN de votre entreprise (facultatif)"
    }
  },
  "dashboard": {
    "adminTitle": "Bienvenue sur le portail d'administration",
    "adminMessage": "Votre compte administrateur n'est pas rattaché à un fournisseur. Utilisez le menu <strong>Administration</strong> pour gérer les fournisseurs, clients et utilisateurs du portail.",
    "adminButton": "Administration",
    "unpaidInvoices_one": "{{count}} facture en attente de paiement",
    "unpaidInvoices_other": "{{count}} factures en attente de paiement",
    "viewInvoices": "Voir les factures",
    "invoices": "Factures",
    "orders": "Commandes",
    "shipments": "Livraisons",
    "openTickets": "Tickets ouverts",
    "recentInvoices": "Factures récentes",
    "recentOrders": "Commandes récentes",
    "noInvoices": "Aucune facture",
    "noOrders": "Aucune commande",
    "paid": "Payée",
    "pending": "En attente"
  },
  "invoices": {
    "loadError": "Impossible de charger les factures.",
    "totalInvoices": "Total factures",
    "totalAmount": "Montant total",
    "outstanding": "Impayé",
    "searchPlaceholder": "Rechercher une facture...",
    "filterAll": "Tous les statuts",
    "filterPaid": "Payées",
    "filterUnpaid": "Impayées",
    "filterDraft": "Brouillons",
    "colRef": "Référence",
    "colDate": "Date",
    "colDue": "Échéance",
    "colAmount": "Montant",
    "colStatus": "Statut",
    "colActions": "Actions",
    "notFound": "Aucune facture trouvée",
    "statusPaid": "Payée",
    "statusUnpaid": "Impayée",
    "statusDraft": "Brouillon",
    "statusCancelled": "Annulée"
  },
  "lineItems": {
    "title": "Lignes",
    "colRef": "Réf.",
    "colDescription": "Désignation",
    "colQty": "Qté",
    "colUnitPrice": "PU HT",
    "colTotal": "Total HT",
    "colVat": "TVA",
    "noLines": "Aucune ligne",
    "moreLines": "+ {{count}} autre(s) ligne(s)",
    "previewLoading": "Chargement des lignes...",
    "addToCart": "Ajouter au panier"
  },
  "invoiceDetail": {
    "notFound": "Facture non trouvée",
    "backToList": "← Retour aux factures",
    "title": "Facture {{ref}}",
    "issuedOn": "Émise le {{date}}",
    "downloadPdf": "Télécharger PDF",
    "downloading": "Téléchargement...",
    "addInvoiceToCart": "Réajouter au panier",
    "customer": "Client",
    "generalInfo": "Informations générales",
    "invoiceDate": "Date de facture",
    "dueDate": "Date d'échéance",
    "creationDate": "Date de création",
    "customerRef": "Référence client",
    "amounts": "Montants",
    "totalExclTax": "Total HT",
    "vat": "TVA",
    "totalInclTax": "Total TTC",
    "remaining": "Reste à payer",
    "notes": "Notes",
    "paAlreadySubmitted": "Déjà soumise",
    "paSubmitted": "soumise",
    "submitToPA": "Soumettre à la PA"
  },
  "proposalDetail": {
    "notFound": "Devis non trouvé",
    "backToList": "← Retour aux devis",
    "title": "Devis {{ref}}",
    "createdOn": "Créé le {{date}}",
    "downloadPdf": "Télécharger PDF",
    "downloading": "Téléchargement...",
    "sign": "Signer",
    "signing": "Signature en cours...",
    "generalInfo": "Informations générales",
    "proposalDate": "Date du devis",
    "validityDate": "Date de validité",
    "creationDate": "Date de création",
    "customerRef": "Référence client",
    "amounts": "Montants",
    "totalExclTax": "Total HT",
    "vat": "TVA",
    "totalInclTax": "Total TTC",
    "notes": "Notes",
    "multiClientError": "Le détail d'un devis n'est pas accessible en mode multi-clients. Veuillez sélectionner un client via la barre de recherche.",
    "customer": "Client",
    "sendForSignature": "Envoyer pour signature",
    "sendingForSignature": "Envoi en cours...",
    "sendForSignatureSuccess": "Le lien de signature pour le devis {{ref}} a été envoyé au client.",
    "signPolling": "Vérification de la signature en cours pour le devis {{ref}}…",
    "signedTitle": "Devis {{ref}} signé",
    "signedBody": "La signature électronique a bien été enregistrée."
  },
  "shipmentDetail": {
    "notFound": "Livraison non trouvée",
    "backToList": "← Retour aux livraisons",
    "title": "Livraison {{ref}}",
    "createdOn": "Créée le {{date}}",
    "generalInfo": "Informations générales",
    "creationDate": "Date de création",
    "deliveryDate": "Date de livraison",
    "trackingTitle": "Suivi du colis",
    "trackPackage": "Suivre le colis",
    "notes": "Notes",
    "multiClientError": "Le détail d'une livraison n'est pas accessible en mode multi-clients. Veuillez sélectionner un client via la barre de recherche."
  },
  "orders": {
    "loadError": "Impossible de charger les commandes.",
    "totalOrders": "Total commandes",
    "totalAmount": "Montant total",
    "searchPlaceholder": "Rechercher une commande...",
    "colRef": "Référence",
    "colDate": "Date",
    "colDelivery": "Livraison prévue",
    "colAmount": "Montant",
    "colStatus": "Statut",
    "notFound": "Aucune commande trouvée",
    "statusDraft": "Brouillon",
    "statusValidated": "Validée",
    "statusInProgress": "Expédition en cours",
    "statusShipped": "Expédiée",
    "statusCancelled": "Annulée"
  },
  "orderDetail": {
    "notFound": "Commande non trouvée",
    "backToList": "← Retour aux commandes",
    "title": "Commande {{ref}}",
    "createdOn": "Créée le {{date}}",
    "downloadPdf": "Télécharger PDF",
    "downloading": "Téléchargement...",
    "generalInfo": "Informations générales",
    "orderDate": "Date de commande",
    "creationDate": "Date de création",
    "deliveryDate": "Date de livraison",
    "customerRef": "Référence client",
    "amounts": "Montants",
    "totalExclTax": "Total HT",
    "vat": "TVA",
    "totalInclTax": "Total TTC",
    "billingStatus": "Statut de facturation",
    "billed": "Facturée",
    "notBilled": "Non facturée",
    "notes": "Notes",
    "customer": "Client",
    "pdfError": "Aucune donnée PDF reçue du serveur",
    "pdfDownloadError": "Erreur lors du téléchargement du PDF",
    "addOrderToCart": "Réajouter au panier"
  },
  "ticketDetail": {
    "backToList": "Retour aux tickets",
    "notFound": "Ticket non trouvé",
    "loadError": "Impossible de charger le ticket.",
    "sendError": "Erreur lors de l'envoi du message.",
    "trackId": "Track ID",
    "createdOn": "Créé le",
    "type": "Type",
    "category": "Catégorie",
    "priority": "Priorité",
    "progress": "Progression",
    "description": "Description",
    "conversation": "Conversation",
    "noMessages": "Aucun message dans la conversation",
    "support": "Support",
    "user": "Utilisateur #{{id}}",
    "private": "Privé",
    "messagePlaceholder": "Écrire un message...",
    "attachAudio": "Joindre un fichier audio",
    "transcribing": "Transcription...",
    "send": "Envoyer",
    "closed": "Ce ticket est fermé. Vous ne pouvez plus y répondre."
  },
  "shipments": {
    "loadError": "Impossible de charger les expéditions.",
    "totalShipments": "Total expéditions",
    "searchPlaceholder": "Rechercher une expédition ou un numéro de suivi...",
    "colRef": "Référence",
    "colDate": "Date",
    "colDateCreation": "Date création",
    "colDateDelivery": "Date livraison",
    "colTracking": "Numéro de suivi",
    "trackPackage": "Suivre le colis",
    "colStatus": "Statut",
    "colAddress": "Adresse",
    "notFound": "Aucune expédition trouvée",
    "statusDraft": "Brouillon",
    "statusValidated": "Validée",
    "statusClosed": "Clôturée",
    "statusCancelled": "Annulée"
  },
  "tickets": {
    "openTickets": "Tickets ouverts",
    "newTicket": "Nouveau ticket",
    "searchPlaceholder": "Rechercher un ticket...",
    "colRef": "Référence",
    "colSubject": "Sujet",
    "colDate": "Date création",
    "colStatus": "Statut",
    "colProgress": "Progression",
    "notFound": "Aucun ticket trouvé",
    "trackId": "Track ID: {{id}}",
    "modalTitle": "Nouveau ticket de support",
    "subjectLabel": "Sujet *",
    "subjectPlaceholder": "Décrivez brièvement votre demande",
    "messageLabel": "Message *",
    "messagePlaceholder": "Décrivez votre problème en détail...",
    "audioLabel": "Fichier audio (optionnel)",
    "audioButton": "Joindre un fichier audio (demande d'intervention)",
    "audioHint": "Le fichier sera transcrit automatiquement et ajouté au ticket. Formats : mp3, wav, webm, m4a (max 25 Mo)",
    "audioSizeError": "Le fichier audio ne doit pas dépasser 25 Mo.",
    "typeLabel": "Type",
    "categoryLabel": "Catégorie",
    "priorityLabel": "Priorité",
    "typeIssue": "Problème",
    "typeQuestion": "Question",
    "typeRequest": "Demande",
    "catTechnical": "Technique",
    "catBilling": "Facturation",
    "catOther": "Autre",
    "priLow": "Basse",
    "priNormal": "Normale",
    "priHigh": "Haute",
    "priCritical": "Critique",
    "createError": "Erreur lors de la création du ticket",
    "transcribing": "Transcription en cours...",
    "creating": "Création...",
    "createButton": "Créer le ticket",
    "loadError": "Impossible de charger les tickets.",
    "phoneSupport": "Support téléphonique IA disponible",
    "phoneSupportHint": "Notre assistant vocal peut créer votre ticket en quelques secondes. Appelez directement :"
  },
  "chatbot": {
    "title": "Assistant SAV",
    "subtitle": "Création guidée de ticket",
    "openButton": "Créer via l'assistant",
    "defaultWelcome": "Bonjour ! Je vais vous aider à créer votre demande de SAV.",
    "describePrompt": "Décrivez votre problème. J'analyserai votre description et ne poserai que les questions nécessaires.",
    "descriptionPlaceholder": "Ex : Mon extincteur modèle XY-42 installé en 2022 est tombé en panne le 12 mars, il y a une fuite de gaz...",
    "extracting": "J'analyse votre description...",
    "extractedFields": "Informations identifiées :",
    "missingFields": "Merci !",
    "askField": "Pouvez-vous m'indiquer {{field}} ?",
    "noExtraction": "Merci !",
    "extractionFailed": "Merci !",
    "statusAnalysing": "Analyse en cours...",
    "autoFilled": "{{count}} champ(s) pré-rempli(s) automatiquement",
    "defaultSubject": "Demande SAV",
    "loadError": "Impossible de charger le chatbot. Veuillez utiliser le formulaire classique.",
    "inputPlaceholder": "Votre réponse...",
    "listeningPlaceholder": "Parlez maintenant...",
    "skip": "Passer",
    "voiceOn": "Activer le mode vocal",
    "voiceOff": "Désactiver le mode vocal",
    "voiceActive": "Mode vocal activé — les questions sont lues à voix haute",
    "statusSpeaking": "En train de parler...",
    "statusListening": "En écoute — parlez maintenant",
    "question": "Question {{current}} / {{total}}",
    "summaryIntro": "Voici le récapitulatif de votre demande :",
    "confirmPrompt": "Souhaitez-vous créer le ticket avec ces informations ?",
    "confirm": "Créer le ticket",
    "modify": "Tout recommencer",
    "editAnswer": "Corriger la réponse",
    "reviewPrompt": "Avez-vous quelque chose à ajouter ou à modifier ?",
    "reviewYes": "Oui, je voudrais modifier",
    "reviewNo": "Non, c'est correct",
    "reviewInputPrompt": "Décrivez ce que vous souhaitez ajouter ou modifier.",
    "reviewInputPlaceholder": "Précisez ou corrigez les informations...",
    "reviewDirectPlaceholder": "Ou saisissez directement votre correction...",
    "summaryCorrectPlaceholder": "Corriger (ex: changer le nom par Michel)...",
    "reviewExtracting": "Mise à jour de votre demande...",
    "reviewUpdated": "Informations mises à jour :",
    "reviewNoValueFound": "Je n'ai pas trouvé de nouvelle valeur dans votre message. Pouvez-vous préciser, par exemple : \"changer l'heure par 10h00\" ?",
    "summaryVoiceHint": "Dites confirmer pour valider, ou décrivez une modification.",
    "validationTime": "Format d'heure invalide. Exemples acceptés : 8h30, 14:00, 08:30",
    "validationDate": "Format de date invalide. Exemples : 25/03/2026, 2026-03-25",
    "validationNumber": "Veuillez saisir une valeur numérique",
    "validationEmail": "Adresse email invalide",
    "validationPhone": "Numéro de téléphone invalide (8 à 15 chiffres attendus)",
    "validationGeneric": "La valeur saisie n'est pas valide",
    "placeholderTime": "Ex : 8h30 ou 14:00",
    "placeholderNumber": "Ex : 42",
    "placeholderEmail": "Ex : nom@domaine.fr",
    "placeholderPhone": "Ex : 06 12 34 56 78",
    "restart": "D'accord, reprenons depuis le début.",
    "submitting": "Création du ticket en cours...",
    "ticketCreated": "Ticket créé avec succès.",
    "submitError": "Une erreur est survenue lors de la création du ticket. Veuillez réessayer.",
    "close": "Fermer"
  },
  "catalog": {
    "title": "Catalogue",
    "subtitle": "{{count}} références disponibles",
    "cart": "Panier",
    "searchPlaceholder": "Rechercher un produit ou service...",
    "notFound": "Aucun produit trouvé",
    "ref": "Réf: {{ref}}",
    "typeProduct": "Produit",
    "typeService": "Service",
    "priceExclTax": "Prix HT",
    "priceInclTax": "Prix TTC",
    "inStock": "En stock: {{count}}",
    "outOfStock": "Rupture de stock",
    "documentation": "Documentation",
    "productWebsite": "Voir sur le site web",
    "viewDoc": "Visualiser",
    "downloadDoc": "Télécharger",
    "addedToCart": "Ajouté au panier",
    "addToCart": "Ajouter au panier",
    "loadError": "Impossible de charger les produits. Veuillez réessayer plus tard.",
    "docsModalTitle": "Documentation",
    "noDocsAvailable": "Aucun document disponible pour ce produit",
    "filterAll": "Tous les produits",
    "filterPurchased": "Récemment achetés",
    "loadingMore": "Chargement en cours...",
    "noMoreProducts": "Tous les produits sont affichés",
    "chooseVariant": "Choisir une variante",
    "selectVariant": "Sélectionner une variante",
    "noVariants": "Aucune variante disponible pour ce produit."
  },
  "cart": {
    "title": "Panier",
    "empty": "Votre panier est vide",
    "browseProducts": "Parcourir le catalogue",
    "product": "Produit",
    "quantity": "Quantité",
    "unitPrice": "Prix unitaire",
    "total": "Total",
    "orderTotal": "Total commande",
    "placeOrder": "Passer la commande",
    "ordering": "Commande en cours...",
    "orderSuccess": "Commande passée avec succès !",
    "orderError": "Erreur lors de la création de la commande.",
    "remove": "Supprimer",
    "continueShop": "Continuer mes achats",
    "excl": "HT",
    "incl": "TTC",
    "totalExclTax": "Total HT",
    "totalInclTax": "Total TTC",
    "stockError": "Stock insuffisant pour un ou plusieurs produits. Vérifiez les disponibilités et réessayez."
  },
  "documents": {
    "title": "Documents",
    "totalDocuments": "Total documents",
    "showing": "affichés : {{count}} / {{total}}",
    "searchPlaceholder": "Rechercher un document ou une référence...",
    "filterAll": "Tous les types",
    "filterSociete": "Société",
    "filterInvoices": "Factures",
    "filterOrders": "Commandes",
    "filterShipments": "Expéditions",
    "filterTickets": "Tickets",
    "notFound": "Aucun document trouvé",
    "noneAvailable": "Aucun document disponible",
    "loadError": "Impossible de charger les documents. Veuillez réessayer plus tard.",
    "labelType": "Type",
    "labelSize": "Taille",
    "labelDate": "Date",
    "moduleSociete": "Société",
    "moduleInvoice": "Facture",
    "moduleOrder": "Commande",
    "moduleShipment": "Expédition",
    "moduleTicket": "Ticket"
  },
  "proposals": {
    "title": "Devis",
    "subtitle_one": "{{count}} devis",
    "subtitle_other": "{{count}} devis",
    "notFound": "Aucun devis disponible",
    "noneFound": "Aucun devis ne correspond aux filtres sélectionnés",
    "searchPlaceholder": "Rechercher un devis...",
    "loadError": "Impossible de charger les devis.",
    "colRef": "Référence",
    "colDate": "Date",
    "colValidity": "Validité",
    "colAmountExcl": "Montant HT",
    "colAmountIncl": "Montant TTC",
    "colStatus": "Statut",
    "colActions": "Actions",
    "customerRef": "Réf. client: {{ref}}",
    "downloadPdf": "Télécharger le PDF",
    "sign": "Signer",
    "signTitle": "Signer le devis",
    "signConfirm": "Voulez-vous initier la signature électronique du devis {{ref}} ?",
    "signError": "Erreur lors de la demande de signature. Veuillez réessayer.",
    "signSuccessTitle": "Invitation à signer créée pour le devis {{ref}}",
    "signSuccessBody": "Un email avec le lien de signature vous a été envoyé. Vous pouvez également signer directement depuis cette page :",
    "signNow": "Signer maintenant",
    "statusCancelled": "Annulé",
    "statusDraft": "Brouillon",
    "statusValidated": "Validé",
    "statusSigned": "Signé",
    "statusUnsigned": "Non signé",
    "statusUnknown": "Inconnu",
    "signPolling": "Vérification de la signature en cours pour le devis {{ref}}…",
    "signedTitle": "Devis {{ref}} signé",
    "signedBody": "La signature électronique a bien été enregistrée."
  },
  "proposalSignature": {
    "title": "Envoyer pour signature",
    "subtitle": "Sélectionnez le contact destinataire pour le devis {{ref}}",
    "noContacts": "Aucun contact ni adresse e-mail trouvé pour ce devis ou son entreprise dans l'ERP. Veuillez définir un contact ou une adresse e-mail sur le tiers dans l'ERP avant d'envoyer.",
    "loadError": "Impossible de charger les contacts de ce devis.",
    "sendError": "Erreur lors de l'envoi de l'invitation.",
    "contactFound": "Contact",
    "selectContact": "Sélectionnez un contact",
    "send": "Envoyer l'invitation",
    "sent": "Invitation envoyée avec succès !"
  },
  "adminProposals": {
    "title": "Devis & Signatures",
    "selectCustomer": "Sélectionnez un client pour afficher ses devis",
    "searchCustomer": "Rechercher un client...",
    "noProposals": "Aucun devis trouvé pour ce client",
    "sendInvite": "Envoyer l'invitation",
    "resend": "Relancer",
    "confirmSend": "Envoyer une invitation de signature électronique pour le devis {{ref}} à {{email}} ?",
    "inviteSent": "Invitation envoyée à {{email}}",
    "colRef": "Référence",
    "colDate": "Date",
    "colValidity": "Validité",
    "colTotal": "Total HT",
    "colStatus": "Statut ERP",
    "colSignature": "Signature",
    "sigNone": "Non envoyé",
    "sigPending": "En attente",
    "sigSigned": "Signé",
    "sigRefused": "Refusé",
    "sigExpired": "Expiré",
    "downloadPdf": "Télécharger PDF",
    "viewSigned": "Doc signé"
  },
  "projects": {
    "title": "Projets",
    "totalProjects": "Total projets",
    "searchPlaceholder": "Rechercher un projet...",
    "notFound": "Aucun projet trouvé",
    "loadError": "Impossible de charger les projets.",
    "statusDraft": "Brouillon",
    "statusValidated": "Validé",
    "statusClosed": "Clôturé",
    "statusUnknown": "Inconnu",
    "colRef": "Référence",
    "colTitle": "Titre",
    "colDate": "Date",
    "colDateStart": "Date début",
    "colDateEnd": "Date fin",
    "colBudget": "Budget",
    "colStatus": "Statut",
    "colProgress": "Avancement"
  },
  "gallery": {
    "filterAll": "Tous",
    "filterImages": "Images",
    "filterFiles": "Fichiers",
    "searchPlaceholder": "Rechercher...",
    "items_one": "{{count}} élément",
    "items_other": "{{count}} éléments",
    "allModules": "Tous les modules",
    "notFound": "Aucun document trouvé",
    "download": "Télécharger",
    "moduleSociete": "Fournisseur",
    "moduleInvoice": "Facture",
    "moduleOrder": "Commande",
    "moduleShipment": "Livraison",
    "moduleTicket": "Support",
    "moduleProposal": "Devis",
    "moduleProject": "Projet",
    "loadMore": "Charger plus ({{remaining}} restants)"
  },
  "revisions": {
    "title": "Révisions produits",
    "subtitle": "Suivi des échéances de révision pour vos produits",
    "colProduct": "Produit",
    "colLastPurchase": "Dernier achat",
    "colNextRevision": "Prochaine révision",
    "colStatus": "Statut",
    "colAction": "Action",
    "statusOk": "À jour",
    "statusDue": "Bientôt due",
    "statusOverdue": "En retard",
    "acknowledge": "Confirmer prise en charge",
    "acknowledged": "Prise en charge confirmée",
    "noRevisions": "Aucune révision planifiée",
    "noPurchase": "Jamais acheté",
    "loadError": "Erreur lors du chargement des révisions",
    "confirmAck": "Confirmer que la révision de \"{{label}}\" a bien été effectuée ?",
    "ackSuccess": "Révision confirmée",
    "ackError": "Erreur lors de la confirmation"
  },
  "adminRevisions": {
    "title": "Révisions produits",
    "tabRules": "Règles de révision",
    "tabSchedules": "Calendrier",
    "syncBtn": "Synchroniser depuis ERP",
    "syncSuccess": "Synchronisation terminée ({{count}} entrées)",
    "syncError": "Erreur de synchronisation",
    "ruleProduct": "Référence produit",
    "ruleLabel": "Libellé révision",
    "ruleInterval": "Intervalle (jours)",
    "ruleErp": "ERP",
    "ruleActive": "Actif",
    "addRule": "Ajouter une règle",
    "editRule": "Modifier la règle",
    "deleteRule": "Supprimer la règle",
    "deleteConfirm": "Supprimer cette règle de révision ?",
    "colCustomer": "Client",
    "colStatus": "Statut",
    "colLastPurchase": "Dernier achat",
    "colNextRevision": "Prochaine révision",
    "filterAll": "Tous les statuts",
    "noSchedules": "Aucune révision dans le calendrier",
    "noRules": "Aucune règle de révision configurée"
  },
  "shop": {
    "title": "Boutique en ligne",
    "titleFor": "Boutique — {{name}}",
    "subtitle_one": "{{count}} produit disponible",
    "subtitle_other": "{{count}} produits disponibles",
    "subtitle": "{{count}} produits disponibles",
    "searchPlaceholder": "Rechercher un produit...",
    "notFound": "Aucun produit trouvé",
    "loadError": "Impossible de charger les produits. Veuillez réessayer plus tard.",
    "shopDisabledTitle": "Boutique temporairement indisponible",
    "shopDisabledMessage": "La boutique en ligne de ce fournisseur n'est pas disponible pour le moment.",
    "cart": "Panier",
    "cartTitle": "Mon panier",
    "cartEmpty": "Votre panier est vide",
    "checkout": "Valider le panier",
    "checkoutTitle": "Finaliser votre commande",
    "checkoutInfo": "Pour valider votre commande, veuillez vous connecter à votre espace client ou créer un compte.",
    "loginTitle": "Se connecter",
    "loginAndOrder": "Se connecter et commander",
    "loginError": "Identifiants incorrects. Veuillez réessayer.",
    "noAccount": "Pas encore de compte ?",
    "registerLink": "Faire une demande d'accès",
    "tabLogin": "Se connecter",
    "tabGuest": "Commander sans compte",
    "guestFirstname": "Prénom",
    "guestLastname": "Nom",
    "guestEmail": "Email",
    "guestPhone": "Téléphone",
    "guestCompany": "Société",
    "guestSiren": "SIREN (optionnel)",
    "guestNotes": "Remarques (optionnel)",
    "guestSubmit": "Envoyer ma commande",
    "guestSending": "Envoi en cours...",
    "guestSuccessTitle": "Commande reçue !",
    "guestSuccessDetail": "Votre demande de commande a bien été enregistrée. Un email de confirmation vous a été envoyé. Votre commande sera traitée dès que votre inscription aura été validée.",
    "guestError": "Une erreur est survenue. Veuillez réessayer.",
    "categoryAll": "Toutes les catégories"
  },
  "mesCredits": {
    "title": "Mes crédits",
    "refresh": "Actualiser",
    "balance": "Solde de crédits disponible",
    "creditsUnit": "crédits",
    "balanceHint": "Utilisés uniquement pour les consommations au-delà de vos quotas.",
    "creditsRule": "1 € = 1 000 crédits",
    "lowBalance": "Solde faible — rechargez votre compte pour éviter toute interruption",
    "recharge": "Recharger",
    "chooseAmount": "Choisir le montant",
    "customAmount": "Montant personnalisé :",
    "amountHint": "Minimum 10 € HT — TVA applicable en sus",
    "continue": "Continuer — {{amount}} € HT",
    "loading": "Chargement…",
    "securePayment": "Paiement sécurisé",
    "amountHT": "Montant HT",
    "vat": "TVA ({{rate}}%)",
    "totalTTC": "Total TTC",
    "payBtn": "Payer {{amount}} € TTC",
    "processing": "Traitement…",
    "retryPayment": "Recommencer avec un nouveau paiement",
    "paymentSuccess": "Paiement validé !",
    "paymentSuccessMsg": "Votre compte a été crédité. Nouveau solde :",
    "quotaTitle": "Quotas du mois en cours",
    "unlimited": "Illimité",
    "esignatures": "Signatures électroniques",
    "emails": "Emails",
    "aiTokens": "Tokens IA",
    "quotaWarning": "Vous approchez de vos limites sur : {{resources}}. Pensez à changer de formule.",
    "historyTitle": "Historique récent",
    "noTransactions": "Aucune transaction",
    "colDescription": "Description",
    "colCredits": "Crédits",
    "paymentError": "Erreur de paiement",
    "creditError": "Paiement validé mais erreur lors du crédit. Contactez le support.",
    "loadError": "Erreur lors du chargement",
    "initError": "Erreur lors de l'initialisation du paiement"
  },
  "profile": {
    "title": "Mon Compte",
    "sectionIdentity": "Identité",
    "sectionPassword": "Changer le mot de passe",
    "firstName": "Prénom",
    "lastName": "Nom",
    "loadError": "Impossible de charger le profil.",
    "passwordMismatch": "Les mots de passe ne correspondent pas.",
    "subtitle": "Informations de votre compte",
    "saveError": "Erreur lors de l'enregistrement.",
    "saveSuccess": "Profil sauvegardé.",
    "save": "Enregistrer",
    "saving": "Sauvegarde…",
    "description": "Description",
    "email": "Email",
    "passwordHint": "Laissez vide pour conserver le mot de passe actuel.",
    "password": "Mot de passe",
    "newPassword": "Nouveau mot de passe",
    "confirmPassword": "Confirmer le mot de passe"
  },
  "tarifs": {
    "title": "Abonnement",
    "subtitle": "Consultez votre abonnement en cours et choisissez le pack adapté à vos besoins.",
    "quota": {
      "users": "Utilisateurs",
      "clients": "Clients",
      "signatures": "Signatures",
      "aiTokens": "Tokens IA",
      "emails": "Emails/mois",
      "catalog": "Produits boutique"
    },
    "planCard": {
      "currentPlan": "Plan actuel",
      "onQuote": "Sur devis",
      "customQuotas": "Quotas personnalisés",
      "customValue": "Sur mesure",
      "contactUs": "Nous contacter",
      "perPackPerMonth": "/pack/mois",
      "billingMonthly": "HT — facturation mensuelle",
      "selected": "Sélectionné",
      "choosePlan": "Choisir ce plan"
    },
    "proration": {
      "planChange": "Changement de plan",
      "newPlan": "Nouveau plan ({{name}})",
      "proratedCredit": "Crédit proraté ({{remaining}}j / {{total}}j)",
      "amountDueHT": "À payer HT",
      "vat": "TVA ({{rate}}%)",
      "totalTTC": "Total TTC aujourd'hui",
      "fromDate": "À partir du {{date}} : {{price}} € HT / mois",
      "restart": "Recommencer",
      "paying": "Paiement…",
      "pay": "Payer {{amount}} € TTC",
      "activationError": "Paiement validé mais erreur lors de l'activation. Contactez le support.",
      "stripeError": "Erreur de paiement"
    },
    "cart": {
      "empty": "Sélectionnez un plan pour commencer",
      "yourOrder": "Votre commande",
      "packCount": "Nombre de packs",
      "effectiveQuotas": "Quotas effectifs",
      "totalHT": "Total HT / mois",
      "vat": "TVA (20%)",
      "totalTTC": "Total TTC / mois",
      "processing": "Traitement en cours…",
      "order": "Commander",
      "billingInfo": "Facturation mensuelle — résiliable à tout moment"
    },
    "sub": {
      "customPlan": "Plan personnalisé",
      "monthly": "Abonnement mensuel",
      "active": "Actif",
      "dueDate": "Date d'échéance",
      "nextBilling": "Prochaine facturation",
      "creditBalance": "Solde crédits",
      "effectiveQuotas": "Quotas effectifs",
      "noSubscription": "Aucun abonnement actif. Choisissez un plan ci-dessous pour commencer.",
      "pack_one": "{{count}} pack",
      "pack_other": "{{count}} packs",
      "editQty": "Modifier le nombre de packs ({{packs}} actuellement)",
      "editQtyTitle": "Modifier le nombre de packs",
      "confirm": "Confirmer",
      "inProgress": "En cours…",
      "pendingChangeTitle": "Changement planifié :",
      "pendingChangeBody": "passage au plan {{name}}{{packs}} le {{date}}. Votre plan actuel reste actif jusqu'à cette date.",
      "pendingPacks": " × {{count}} packs"
    },
    "plans": {
      "changePlan": "Changer de plan",
      "choosePlan": "Choisissez votre plan",
      "noPlans": "Aucun plan disponible pour le moment.",
      "howTitle": "Comment fonctionnent les packs ?",
      "howDesc1": "Chaque pack vous donne accès aux quotas indiqués (utilisateurs, clients, signatures, tokens IA, emails).",
      "howDesc2": "Vous pouvez acheter plusieurs packs pour multiplier vos quotas proportionnellement."
    },
    "msg": {
      "nextBillingDate": "la prochaine date de renouvellement",
      "scheduleDowngrade": "La baisse vers le plan \"{{name}}\" sera effective le {{date}}. Votre plan actuel reste actif jusqu'à cette date.",
      "subscriptionActivated": "Abonnement \"{{name}}\" activé avec succès !",
      "planActivated": "Plan \"{{name}}\" activé avec succès !",
      "subscriptionError": "Erreur lors de l'abonnement.",
      "connectionError": "Erreur de connexion. Veuillez réessayer.",
      "qtyReduced_one": "La réduction à {{count}} pack sera effective le {{date}}.",
      "qtyReduced_other": "La réduction à {{count}} packs sera effective le {{date}}.",
      "qtyUpdated_one": "Quantité mise à jour : {{count}} pack.",
      "qtyUpdated_other": "Quantité mise à jour : {{count}} packs.",
      "modifyError": "Erreur lors de la modification."
    }
  },
  "admin": {
    "erpImpersonation": {
      "title": "Visualiser en tant qu'admin ERP",
      "select": "Mode admin ERP",
      "viewAll": "Voir tout (super_admin)",
      "banner": "Visualisation en tant qu'administrateur de l'ERP : {{name}}",
      "exit": "Quitter ce mode"
    },
    "dashboard": {
      "title": "Administration",
      "recentActivity": "Activité récente",
      "viewAll": "Voir tout",
      "noActivity": "Aucune activité récente",
      "erps": "Fournisseurs",
      "suppliers": "Clients",
      "users": "Utilisateurs",
      "activeUsers": "Utilisateurs actifs",
      "schemaMismatchTitle": "Version de la base de données incompatible",
      "schemaMismatchDesc": "Le schéma en base de données est en version {{db}}, mais le code requiert la version {{required}}. Veuillez appliquer le script de migration correspondant.",
      "schemaMismatchRequired": "requise",
      "pendingOrdersAlertTitle": "{{count}} commande(s) invité(s) en attente de traitement",
      "pendingOrdersAlertDesc": "Des clients non inscrits ont passé des commandes depuis la boutique publique. Veuillez les traiter.",
      "pendingOrdersAlertAction": "Voir les commandes"
    },
    "erps": {
      "title": "Gestion des fournisseurs",
      "fields": {
        "common": {
          "api_key": "Clé API",
          "api_secret": "Secret API",
          "api_version": "Version API"
        },
        "dolibarr": {
          "base_url": "URL de base Dolibarr",
          "base_url_help": "URL racine de votre instance Dolibarr, SANS /api/index.php. Le portail ajoutera automatiquement /api/index.php aux requêtes.",
          "api_key": "Clé API (DOLAPIKEY)",
          "api_key_help": "Clé API d'un utilisateur Dolibarr. Menu : Accueil > Configuration > Utilisateurs > [utilisateur] > onglet \"API / Webservices\"."
        },
        "salesforce": {
          "base_url": "Instance URL",
          "base_url_help": "URL de votre instance Salesforce (sans /services/). Se trouve dans Configuration > Informations sur la société.",
          "api_key": "Client ID (Connected App)",
          "api_key_help": "Consumer Key de votre Connected App Salesforce. Configuration > Gestionnaire d'applications > Connected Apps.",
          "api_secret": "Client Secret",
          "api_secret_help": "Consumer Secret de votre Connected App Salesforce.",
          "api_version": "Version API (ex: v59.0)",
          "api_version_help": "Version de l'API REST Salesforce à utiliser.",
          "oauth2Title": "Configuration OAuth2 Salesforce",
          "sf_username": "Nom d'utilisateur API",
          "sf_password": "Mot de passe + Security Token",
          "sf_password_placeholder": "password + security token concaténés",
          "sf_password_help": "Concaténez votre mot de passe et votre Security Token Salesforce"
        },
        "business_central": {
          "base_url": "URL API Business Central",
          "base_url_help": "URL de base de l'API OData v4 Business Central.",
          "api_key": "Client ID (Azure AD)",
          "api_key_help": "Application (client) ID de votre inscription d'application Azure AD.",
          "api_secret": "Client Secret (Azure AD)",
          "api_secret_help": "Valeur du secret client créé dans Azure AD > Certificats et secrets.",
          "api_version_help": "Version de l'API Business Central.",
          "azureTitle": "Configuration Azure AD / Business Central",
          "bc_tenant_id": "Tenant ID (Azure AD)",
          "bc_environment": "Environnement",
          "bc_company_id": "Company ID",
          "bc_company_id_help": "GUID de la société (optionnel si une seule)"
        },
        "csv": {
          "base_url": "Chemin du répertoire data",
          "base_url_help": "Chemin absolu du répertoire contenant les fichiers CSV (invoices.csv, orders.csv, etc.) sur le serveur."
        },
        "default": {
          "base_url": "URL de base",
          "base_url_help": "URL racine de l'API de votre ERP (sans le chemin d'API, qui sera ajouté automatiquement).",
          "api_key_help": "Clé d'authentification API fournie par votre ERP.",
          "api_secret_help": "Secret d'authentification API."
        },
        "odoo": {
          "base_url": "URL de base Odoo",
          "base_url_help": "URL racine de votre instance Odoo (ex: http://localhost:8069). Sans slash final.",
          "api_key": "Clé API Odoo",
          "api_key_help": "Clé API générée dans Odoo : Paramètres > Technique > Clés API utilisateur. Correspond au mot de passe pour l'authentification JSON-RPC.",
          "api_secret": "Login Odoo (email du compte)",
          "api_secret_help": "Adresse email du compte Odoo associé à la clé API (ex: admin@monentreprise.com). Ce login est utilisé pour l'authentification JSON-RPC.",
          "api_version_help": "Version de l'instance Odoo (ex: 17.0). Utilisée pour adapter certains appels API selon la version."
        },
        "bleez": {
          "base_url": "URL API Bleez",
          "base_url_help": "URL de base de l'API Bleez (généralement https://api.bleez.com).",
          "api_key": "Client ID OAuth2",
          "api_key_help": "Identifiant client OAuth2 fourni par le support Bleez.",
          "api_secret": "Client Secret OAuth2",
          "api_secret_help": "Secret client OAuth2 fourni par le support Bleez.",
          "oauth2Title": "Identifiants de connexion Bleez",
          "bleez_username": "Nom d'utilisateur Bleez",
          "bleez_password": "Mot de passe Bleez",
          "bleez_cle_encryptee": "Clé encryptée du dossier",
          "bleez_cle_encryptee_help": "Clé encryptée de votre dossier Bleez. Disponible dans le back-office Bleez (URL du dossier)."
        }
      },
      "addErp": "Ajouter un fournisseur",
      "colType": "Type",
      "colLogo": "Logo",
      "colName": "Nom",
      "colUrl": "URL",
      "colSuppliers": "Clients",
      "colStatus": "Statut",
      "colDate": "Date",
      "colActions": "Actions",
      "none": "Aucun fournisseur configuré",
      "modalCreate": "Ajouter un fournisseur",
      "modalEdit": "Modifier le fournisseur",
      "fieldType": "Type",
      "fieldName": "Nom",
      "fieldDescription": "Description",
      "fieldWebsite": "Site web du fournisseur",
      "fieldWebsiteHint": "Affiché comme lien cliquable sur le logo dans le menu des clients",
      "fieldLogo": "Logo",
      "logoUpload": "Télécharger",
      "logoChange": "Changer",
      "logoHint": "PNG, JPG ou SVG (max 200 Ko)",
      "logoSizeError": "Le logo ne doit pas dépasser 200 Ko",
      "fieldActive": "Actif",
      "shopSettings": "Boutique en ligne",
      "shopEnabled": "Activer la boutique publique",
      "shopShowPrices": "Afficher les prix dans la boutique",
      "testConnection": "Tester la connexion",
      "testOk": "Connexion OK",
      "testFail": "Echec",
      "testSaveFirst": "Enregistrez d'abord le fournisseur avant de tester la connexion.",
      "enabledModules": "Modules activés",
      "erpAdminNotice": "Vous pouvez modifier la description, le logo, le site web, la boutique, les modules activés et le chatbot. Les paramètres de connexion ERP, de facturation et de téléphonie sont gérés par le super-administrateur.",
      "connectionReadOnly": "Les paramètres de connexion ERP sont gérés par le super-administrateur.",
      "colModule": "Module",
      "colLastTest": "Dernier test",
      "colActivatable": "Activable",
      "colEnabled": "Activé",
      "moduleNotTested": "Non testé",
      "sttVocabulary": "Vocabulaire de transcription audio",
      "sttVocabularyHint": "Mots ou expressions métier séparés par des virgules, pour améliorer la reconnaissance vocale",
      "sttVocabularyPlaceholder": "ex: Dolibarr, ERP, facturation, bon de commande, devis...",
      "chatbotTitle": "Chatbot SAV (création guidée de tickets)",
      "chatbotHint": "Permet aux clients de créer un ticket en répondant à des questions prédéfinies",
      "chatbotEnabled": "Activé",
      "chatbotWelcome": "Message d'accueil du chatbot",
      "chatbotWelcomePlaceholder": "ex: Bonjour ! Je vais vous aider à créer votre demande de SAV. Répondez aux quelques questions suivantes.",
      "chatbotQuestions": "Questions à poser",
      "chatbotQuestionLabel": "Intitulé de la question...",
      "chatbotTypeText": "Texte court",
      "chatbotTypeTextarea": "Texte long",
      "chatbotTypeDate": "Date",
      "chatbotTypeTime": "Heure",
      "chatbotTypeNumber": "Nombre",
      "chatbotTypeEmail": "Email",
      "chatbotTypePhone": "Téléphone",
      "chatbotTypeSelect": "Choix multiple",
      "chatbotFieldSubject": "→ Sujet du ticket",
      "chatbotFieldMessage": "→ Corps du message",
      "chatbotFieldType": "→ Type de ticket",
      "chatbotFieldCategory": "→ Catégorie",
      "chatbotFieldSeverity": "→ Priorité",
      "chatbotOptionsPlaceholder": "Options séparées par des virgules (ex: Option A, Option B, Option C)",
      "chatbotRequired": "Réponse obligatoire",
      "chatbotAddQuestion": "Ajouter une question",
      "vapiTitle": "Vapi.ai — Support téléphonique IA",
      "vapiHint": "Connectez un numéro de téléphone IA pour permettre aux clients de créer des tickets par appel vocal",
      "vapiEnabled": "Activé",
      "vapiLanguage": "Langue",
      "vapiVoiceProvider": "Synthèse vocale",
      "vapiVoiceId": "Identifiant de la voix",
      "vapiPhoneNumber": "Numéro de téléphone Vapi",
      "vapiPhoneSelect": "— Sélectionner un numéro —",
      "vapiAssistantId": "ID de l'assistant (géré automatiquement)",
      "vapiSync": "Synchroniser l'assistant Vapi",
      "vapiSyncSuccess": "Assistant synchronisé avec succès",
      "vapiSyncError": "Erreur lors de la synchronisation Vapi",
      "deleteConfirm": "Supprimer le fournisseur \"{{name}}\" ?",
      "connectionSuccess": "Connexion réussie",
      "connectionFail": "Echec de la connexion",
      "testModalTitle": "Test de connexion — {{name}}",
      "testTesting": "Test en cours...",
      "testConnectionStatus": "Connexion générale",
      "testModuleAccess": "Accès aux modules",
      "testModuleCol": "Module",
      "testStatusCol": "Statut",
      "testCountCol": "Éléments",
      "testModuleCount": "{{count}} éléments",
      "readOnlyMode": "Vue en lecture seule — contactez un super-administrateur pour modifier la configuration",
      "fieldSiren": "SIREN",
      "sectionEinvoice": "Facturation électronique (Factur-X)",
      "fieldSiret": "SIRET",
      "fieldVatNumber": "N° TVA intracommunautaire",
      "fieldIban": "IBAN",
      "fieldBic": "BIC / SWIFT",
      "sectionPaConnector": "Connecteur PA / PDP (envoi factures électroniques)",
      "fieldPaProvider": "Partenaire Agréé (PA/PDP)",
      "paNone": "— Aucun —",
      "copyLoginLink": "Copier le lien de connexion",
      "loginLinkCopied": "Lien copié !",
      "copyShopLink": "Copier le lien boutique",
      "shopLinkCopied": "Lien copié !",
      "pageCreate": "Créer un fournisseur",
      "pageEdit": "Modifier le fournisseur",
      "backToList": "Retour aux fournisseurs",
      "sectionGeneral": "Informations générales",
      "sectionGeneralSubtitle": "Identité, logo et coordonnées du fournisseur",
      "sectionConnection": "Connexion ERP",
      "sectionConnectionSubtitle": "Paramètres d'accès à l'API de votre ERP",
      "sectionEinvoiceTitle": "Facturation électronique",
      "sectionEinvoiceSubtitle": "Données légales pour Factur-X et connecteurs PA/PDP",
      "sectionModules": "Boutique & Modules",
      "sectionModulesSubtitle": "Activer ou désactiver les fonctionnalités du portail",
      "sectionChatbot": "Chatbot & Téléphonie",
      "sectionChatbotSubtitle": "Configurer le chatbot SAV et le support téléphonique IA",
      "sectionPayment": "Paiement en ligne",
      "sectionPaymentSubtitle": "Connectez Stripe pour permettre le paiement des factures",
      "stripeSaveFirst": "Enregistrez d'abord le fournisseur pour configurer le paiement Stripe.",
      "fieldSirenHint": "Identifiant unique à 9 chiffres — utilisé pour les liens de connexion et boutique",
      "fieldSirenHelp": "Le SIREN est l'identifiant de l'entreprise (9 chiffres). Il est utilisé pour générer les URLs de connexion et de boutique publique des clients.",
      "fieldSiretHelp": "SIRET = SIREN (9 chiffres) + NIC (5 chiffres). Requis pour la génération de factures électroniques Factur-X.",
      "sirenSiretWarning": "Le SIREN et le SIRET sont recommandés pour la facturation électronique. Certaines fonctionnalités (Chorus Pro, e-facture) peuvent ne pas fonctionner sans ces informations.",
      "fieldVatNumberHelp": "Numéro de TVA intracommunautaire (ex: FR12345678901). Requis pour les échanges B2B transfrontaliers et la facturation électronique.",
      "fieldIbanHelp": "Coordonnées bancaires au format IBAN (ex: FR76 1234 5678 9012 3456 7890 189). Inclus dans les factures électroniques Factur-X pour faciliter le paiement.",
      "fieldBicHelp": "Code BIC / SWIFT de la banque (ex: AGRIFRPP). Complète l'IBAN pour les virements internationaux.",
      "fieldPaProviderHelp": "Sélectionnez un Partenaire Agréé (PA) ou Prestataire de Dématérialisation Partenaire (PDP) pour l'envoi automatique des factures électroniques sur le réseau Chorus Pro.",
      "doc": {
        "dolibarr": {
          "title": "Comment configurer l'accès API Dolibarr ?",
          "step1": "Connectez-vous en tant qu'administrateur sur votre instance Dolibarr",
          "step2": "Allez dans Accueil > Configuration > Utilisateurs > [utilisateur], onglet « API / Webservices »",
          "step3": "Activez l'accès API et copiez la clé DOLAPIKEY générée",
          "link": "Documentation API Dolibarr"
        },
        "salesforce": {
          "title": "Comment configurer une Connected App Salesforce ?",
          "step1": "Dans Configuration, cherchez « Gestionnaire d'applications » et créez une nouvelle Connected App",
          "step2": "Activez OAuth, ajoutez les scopes nécessaires et copiez le Consumer Key et Consumer Secret",
          "step3": "Dans Configuration > Informations sur la société, copiez votre Instance URL",
          "link": "Documentation Connected Apps Salesforce"
        },
        "business_central": {
          "title": "Comment configurer l'accès Azure AD / Business Central ?",
          "step1": "Dans le portail Azure, créez une inscription d'application et copiez l'Application (client) ID",
          "step2": "Dans Certificats et secrets, créez un nouveau secret client et copiez sa valeur",
          "step3": "Dans Business Central, accordez les permissions API à l'application Azure AD",
          "link": "Documentation API Business Central"
        },
        "odoo": {
          "title": "Comment configurer l'accès API Odoo ?",
          "step1": "Connectez-vous sur Odoo et allez dans Paramètres > Technique > Clés API utilisateur",
          "step2": "Créez une nouvelle clé API et copiez-la — elle sert de mot de passe pour l'authentification",
          "step3": "Notez l'adresse email du compte Odoo associé à cette clé (elle sert de login)",
          "link": "Documentation API externe Odoo"
        },
        "sage100": {
          "title": "Comment configurer l'accès API Sage 100 ?",
          "step1": "Ouvrez la console d'administration Sage 100 et activez le serveur API REST",
          "step2": "Créez un utilisateur API dédié avec les droits nécessaires",
          "step3": "Récupérez l'URL de base du serveur Sage 100 et les identifiants API"
        },
        "netsuite": {
          "title": "Comment configurer l'accès API NetSuite ?",
          "step1": "Dans NetSuite, allez dans Configuration > Intégration > Gérer les intégrations et créez une nouvelle intégration",
          "step2": "Activez l'authentification basée sur les tokens (TBA) et copiez le Consumer Key et Consumer Secret",
          "step3": "Créez un Token d'accès pour l'utilisateur API et notez le Token ID et Token Secret",
          "link": "Documentation API REST NetSuite"
        },
        "erpnext": {
          "title": "Comment configurer l'accès API ERPNext / Frappe ?",
          "step1": "Connectez-vous sur ERPNext et allez dans Mon profil > Générer des clés",
          "step2": "Copiez la clé API (api_key) et le secret API (api_secret) générés",
          "step3": "Utilisez l'URL de votre instance Frappe comme URL de base (ex: https://monerpnext.frappe.cloud)",
          "link": "Documentation API Frappe"
        },
        "zoho": {
          "title": "Comment configurer l'accès API Zoho One ?",
          "step1": "Rendez-vous sur la Zoho Developer Console et créez un nouveau client OAuth",
          "step2": "Sélectionnez « Server-based Applications » et copiez le Client ID et Client Secret",
          "step3": "Autorisez les scopes nécessaires et générez un refresh token pour votre compte",
          "link": "Documentation API Zoho CRM"
        },
        "cegid": {
          "title": "Comment configurer l'accès API Cegid XRP Flex ?",
          "step1": "Dans Cegid XRP Flex, allez dans Administration > API et activez l'accès API REST",
          "step2": "Créez un compte de service dédié avec les droits de lecture nécessaires",
          "step3": "Récupérez l'URL de votre tenant Cegid et les identifiants du compte de service"
        },
        "csv": {
          "title": "Comment configurer l'import CSV ?",
          "step1": "Placez vos fichiers CSV dans un répertoire accessible par le serveur web",
          "step2": "Nommez-les selon la convention : invoices.csv, orders.csv, catalog.csv, etc.",
          "step3": "Indiquez le chemin absolu du répertoire dans le champ « Chemin du répertoire data »"
        }
      }
    },
    "customers": {
      "title": "Gestion des clients",
      "addCustomer": "Ajouter un client",
      "filterAll": "Tous",
      "colName": "Nom",
      "colSiren": "SIREN",
      "colErp": "Fournisseur",
      "colErpId": "ID ERP",
      "colEmail": "Email",
      "colCity": "Ville",
      "colUsers": "Utilisateurs",
      "colStatus": "Statut",
      "colActions": "Actions",
      "none": "Aucun client",
      "modalCreate": "Ajouter un client",
      "modalEdit": "Modifier le client",
      "fieldErp": "Fournisseur",
      "fieldErpCustomerId": "ID client dans l'ERP",
      "fieldName": "Nom du client / Raison sociale",
      "fieldSiren": "SIREN",
      "fieldEmail": "Email",
      "fieldPhone": "Téléphone",
      "fieldAddress": "Adresse",
      "fieldCity": "Ville",
      "fieldPostalCode": "Code postal",
      "fieldActive": "Actif",
      "selectErp": "-- Sélectionner --",
      "deleteConfirm": "Supprimer le client \"{{name}}\" ?",
      "syncBtn": "Synchroniser depuis l'ERP",
      "syncTitle": "Synchronisation des clients depuis l'ERP",
      "syncSelectErp": "Fournisseur ERP",
      "syncLimit": "Nombre maximum de clients à importer",
      "syncPreview": "Analyser",
      "syncFoundCount": "{{count}} client(s) disponible(s) dans l'ERP ({{synced}} déjà synchronisé(s))",
      "syncSelectAll": "Tout sélectionner",
      "syncDeselectAll": "Tout désélectionner",
      "syncImport": "Importer la sélection",
      "syncSuccess": "{{imported}} client(s) importé(s), {{skipped}} ignoré(s).",
      "syncNone": "Tous les clients ERP sont déjà présents dans le portail.",
      "syncHint": "Seuls les tiers marqués comme clients dans l'ERP sont proposés.",
      "syncFilters": "Critères de filtrage",
      "syncFilterInvoices": "Avec factures récentes",
      "syncFilterProposals": "Avec devis récents",
      "syncFilterMonths": "{{n}} mois",
      "erpSearch": "Rechercher dans l'ERP",
      "erpSearchPlaceholder": "Saisir la raison sociale...",
      "erpSearchNoResult": "Aucun résultat trouvé dans l'ERP",
      "importCsvTitle": "Importer des clients depuis un fichier CSV",
      "importCsvFormat": "Format attendu (première ligne = en-têtes) :",
      "importCsvHint": "Les colonnes erp_customer_id et customer_name sont obligatoires. Les lignes existantes (même erp_id + erp_customer_id) seront mises à jour.",
      "importCsvFile": "Fichier CSV",
      "importCsvLines": "ligne(s) détectée(s)",
      "importCsvSubmit": "Importer {{count}} ligne(s)",
      "importCsvResult": "{{created}} créé(s), {{updated}} mis à jour.",
      "importCsvErrors": "{{count}} erreur(s) :",
      "importCsvErpRequired": "Veuillez sélectionner un fournisseur ERP",
      "erpIdHelp": {
        "default": {
          "placeholder": "ex: CUST-001",
          "help": "Identifiant unique du client dans l'ERP."
        },
        "dolibarr": {
          "placeholder": "ex: 10",
          "help": "Identifiant numérique du tiers dans Dolibarr, trouvable dans l'URL de la fiche tiers (exemple : ?socid=10)."
        },
        "csv": {
          "placeholder": "ex: CUST-001",
          "help": "Identifiant du client tel qu'il apparaît dans la colonne customer_id de vos fichiers CSV."
        },
        "salesforce": {
          "placeholder": "ex: 001XX000003ABCDEF",
          "help": "Account ID Salesforce (18 caractères). Visible dans l'URL de la fiche Account ou via SOQL : SELECT Id, Name FROM Account."
        },
        "business_central": {
          "placeholder": "ex: 10000",
          "help": "Numéro du client dans Business Central (champ No. de la fiche Customer). Accessible via Clients > fiche client > champ No."
        },
        "sage100": {
          "placeholder": "ex: C00001",
          "help": "Numéro de compte client dans Sage 100cloud (champ CustomerNo). À retrouver dans Comptabilité clients > Maintenance client > N° de compte."
        },
        "netsuite": {
          "placeholder": "ex: 1234",
          "help": "ID interne de la fiche client dans NetSuite. À retrouver dans Listes > Relations > Clients > colonne ID interne."
        },
        "divalto": {
          "placeholder": "ex: CLI-00001",
          "help": "Code client (Compte tiers) dans Divalto Infinity. À retrouver dans la fiche client, champ « Compte tiers »."
        },
        "erpnext": {
          "placeholder": "ex: CUST-00001",
          "help": "Nom du client (nom du document) dans ERPNext. À retrouver dans Ventes > Client > champ Nom du client."
        },
        "zoho": {
          "placeholder": "ex: 460000000026049",
          "help": "ID client dans Zoho Books (contact_id). À retrouver dans Contacts > fiche client > paramètre URL « contact_id »."
        },
        "cegid": {
          "placeholder": "ex: C00001",
          "help": "Numéro de compte client dans Cegid XRP Flex. À retrouver dans la fiche client sous Compte > Numéro de compte."
        },
        "bleez": {
          "placeholder": "ex: 12345",
          "help": "Identifiant numérique du compte client dans Bleez. Visible dans l'URL de la fiche client ou dans la liste des clients."
        }
      }
    },
    "users": {
      "username": "Nom d'utilisateur",
      "title": "Gestion des utilisateurs",
      "addUser": "Ajouter un utilisateur",
      "colName": "Nom",
      "colEmail": "Email",
      "colRole": "Rôle",
      "colSupplier": "Client",
      "colStatus": "Statut",
      "colLastLogin": "Dernière connexion",
      "colActions": "Actions",
      "none": "Aucun utilisateur",
      "modalCreate": "Ajouter un utilisateur",
      "modalEdit": "Modifier l'utilisateur",
      "fieldName": "Nom",
      "fieldEmail": "Email",
      "fieldRole": "Rôle",
      "fieldSupplier": "Client",
      "fieldPassword": "Mot de passe",
      "fieldActive": "Actif",
      "roleSuperAdmin": "Super Administrateur",
      "roleAdmin": "Administrateur ERP",
      "roleCustomer": "Client",
      "cannotEditOwnRole": "Vous ne pouvez pas modifier votre propre rôle.",
      "roleChangeConfirmTitle": "Confirmation de changement de rôle",
      "roleChangeConfirmMessage": "Confirmez-vous le changement de rôle {{from}} → {{to}} pour l'utilisateur : {{user}} ?",
      "fieldErp": "ERP géré",
      "fieldErpPlaceholder": "Sélectionner un ERP",
      "deleteConfirm": "Supprimer l'utilisateur \"{{name}}\" ?",
      "deleteSelectedConfirm": "Supprimer les {{count}} utilisateurs sélectionnés ?",
      "deleteSelected": "Supprimer la sélection ({{count}})",
      "resetPassword": "Réinitialiser le mot de passe",
      "sendResetEmail": "Envoyer un e-mail de réinitialisation du mot de passe",
      "sendResetEmailSuccess": "E-mail de réinitialisation envoyé à {{email}}",
      "never": "Jamais",
      "colErp": "ERP",
      "viewPermissions": "Voir les permissions",
      "permissionsTitle": "Permissions — {{name}}",
      "permissionsErpAccess": "Accès ERP",
      "permissionsGroups": "Groupes et droits",
      "permissionsNoGroups": "Cet utilisateur n'appartient à aucun groupe.",
      "permissionsNoErp": "Aucun ERP lié.",
      "permissionsAllStatuses": "Tous les statuts",
      "permissionsCustomStatuses": "Statuts : {{list}}",
      "permissionsCustomer": "Client ERP : {{id}}",
      "permissionsErpType": "Type : {{type}}",
      "fieldPasswordHint": "Laisser vide pour ne pas changer"
    },
    "logs": {
      "title": "Journaux d'activité",
      "colUser": "Utilisateur",
      "colAction": "Action",
      "colEntity": "Entité",
      "colDate": "Date",
      "colIp": "IP",
      "none": "Aucune activité enregistrée",
      "filterUser": "Filtrer par utilisateur",
      "filterAction": "Filtrer par action",
      "entries_one": "{{count}} entrée",
      "entries_other": "{{count}} entrées"
    },
    "registrations": {
      "title": "Demandes d'inscription",
      "colType": "Type",
      "colCompany": "Entreprise",
      "colContact": "Contact",
      "colErp": "ERP",
      "colDate": "Date",
      "colStatus": "Statut",
      "colActions": "Actions",
      "none": "Aucune demande",
      "statusPending": "En attente",
      "statusApproved": "Approuvée",
      "statusRejected": "Refusée",
      "typeSupplier": "Fournisseur",
      "typeClient": "Client",
      "supplierInfo": "Fournisseur concerné",
      "approve": "Approuver",
      "reject": "Refuser",
      "rejectReason": "Motif du refus (optionnel)",
      "approveConfirm": "Approuver cette demande d'inscription ?",
      "rejectConfirm": "Refuser cette demande ?"
    },
    "pendingOrders": {
      "title": "Commandes invités",
      "subtitle": "Commandes passées depuis la boutique publique par des utilisateurs non inscrits",
      "none": "Aucune commande invité",
      "colDate": "Date",
      "colCustomer": "Client",
      "colErp": "Fournisseur",
      "colTotal": "Total TTC",
      "colArticle": "Article",
      "colQty": "Qté",
      "colPriceTtc": "Prix TTC",
      "items": "article(s)",
      "statusPending": "En attente",
      "statusProcessed": "Traitée",
      "statusCancelled": "Annulée",
      "status_pending": "En attente",
      "status_processed": "Traitée",
      "status_cancelled": "Annulée",
      "markProcessed": "Marquer comme traitée",
      "markCancelled": "Annuler",
      "detailTitle": "Commande invité",
      "sectionCustomer": "Informations client",
      "sectionCart": "Articles commandés",
      "fieldName": "Nom",
      "fieldEmail": "Email",
      "fieldPhone": "Téléphone",
      "fieldCompany": "Société",
      "fieldErp": "Fournisseur",
      "fieldNotes": "Notes internes",
      "notesPlaceholder": "Ajouter une note interne...",
      "deleteConfirm": "Supprimer cette commande invité ?",
      "sectionProcess": "Créer la commande sur l'ERP",
      "processHint": "Recherchez le client correspondant dans l'ERP, puis validez pour créer la commande.",
      "processSelectCustomer": "Rechercher un client ERP",
      "processSearchPlaceholder": "Nom du client, ville...",
      "processSubmit": "Créer la commande sur l'ERP",
      "processSending": "Création en cours...",
      "processSuccess": "Commande créée avec succès dans l'ERP",
      "processRef": "Référence commande :",
      "processError": "Erreur lors de la création de la commande sur l'ERP",
      "modeExisting": "Client existant",
      "modeNew": "Nouveau client",
      "processNewHint": "Les informations ci-dessous seront utilisées pour créer le tiers dans l'ERP.",
      "processNewName": "Nom du client (entreprise ou nom complet)",
      "processSubmitNew": "Créer le client et la commande",
      "processCustomerCreated": "Client créé dans l'ERP :",
      "confirmProcessedTitle": "Valider la commande",
      "confirmProcessedMessage": "Êtes-vous sûr de vouloir marquer cette commande comme traitée ? Cette action est définitive.",
      "confirmCancelledTitle": "Annuler la commande",
      "confirmCancelledMessage": "Êtes-vous sûr de vouloir annuler cette commande ? Cette action est définitive.",
      "confirmProcessedBtn": "Oui, valider",
      "confirmCancelledBtn": "Oui, annuler"
    }
  },
  "adminGroups": {
    "title": "Groupes d'utilisateurs",
    "subtitle_one": "{{count}} groupe",
    "subtitle_other": "{{count}} groupes",
    "subtitle": "{{count}} groupe(s)",
    "createGroup": "Créer un groupe",
    "editGroup": "Modifier le groupe",
    "name": "Nom",
    "description": "Description",
    "members": "Membres",
    "rights": "Droits",
    "activeGroup": "Groupe actif",
    "nameRequired": "Le nom du groupe est requis",
    "noGroups": "Aucun groupe — cliquez sur « Créer un groupe » pour commencer",
    "manageGroup": "Gérer membres et droits",
    "confirmDelete": "Supprimer le groupe « {{name}} » ? Cette action est irréversible.",
    "tabMembers": "Membres",
    "tabRights": "Droits d'accès",
    "selectUser": "Sélectionner un utilisateur...",
    "addMember": "Ajouter",
    "removeMember": "Retirer du groupe",
    "noMembers": "Aucun membre dans ce groupe",
    "rightsHint": "Cochez les modules auxquels les membres de ce groupe auront accès. Ces droits remplacent la configuration ERP pour les utilisateurs du groupe.",
    "statusFilter": "Filtre de statuts",
    "allStatuses": "Tous les statuts",
    "customStatuses": "Statuts personnalisés",
    "statusPaid": "Payées",
    "statusUnpaid": "Impayées",
    "statusDraft": "Brouillons",
    "statusValidated": "Validés",
    "statusCancelled": "Annulés",
    "statusSigned": "Signés",
    "statusUnsigned": "Non signés",
    "statusInProgress": "En cours",
    "statusShipped": "Expédiés",
    "statusClosed": "Clôturés",
    "noModuleWarning": "Aucun module n'est activé pour ce groupe. Les membres resteront sans accès aux données tant qu'au moins un droit de module n'aura pas été accordé.",
    "accessRead": "Lecture seule",
    "accessWrite": "Lecture et écriture"
  },
  "landing": {
    "signIn": "Connexion",
    "backToTop": "Retour en haut de la page d'accueil",
    "hero": {
      "badge": "Clients finaux & équipes en contact client",
      "title": "Un espace unifié\npour vos clients et vos équipes",
      "subtitle": "L'Espace Client est le point de rencontre entre vos clients finaux et les équipes qui les accompagnent — ADV, SAV, commerciaux. Chacun retrouve, dans un espace unique et à votre marque, les informations issues de vos outils : factures, commandes, devis, documents et support.",
      "tagClients": "Clients finaux",
      "tagAdv": "ADV",
      "tagSav": "SAV",
      "tagSales": "Commerciaux",
      "cta": "Accéder à mon espace"
    },
    "audience": {
      "badge": "Pour qui ?",
      "title": "Un seul portail,\ndeux publics qui se répondent",
      "subtitle": "L'Espace Client n'est pas seulement un extranet pour vos clients : c'est aussi l'outil quotidien des équipes qui sont en contact avec eux. Les deux partagent la même information, en temps réel.",
      "clients": {
        "tag": "Public 1",
        "title": "Vos clients finaux",
        "desc": "Ils accèdent en autonomie, 24 h/24, à tout ce qui les concerne — sans rappeler ni relancer par e-mail.",
        "point1": "Factures, devis et commandes consultables et téléchargeables à tout moment",
        "point2": "Paiement en ligne et signature électronique des devis en quelques clics",
        "point3": "Commande directe au catalogue, avec assistant IA pour trouver le bon produit",
        "point4": "Ouverture et suivi des demandes SAV, documents et historique centralisés"
      },
      "teams": {
        "tag": "Public 2",
        "title": "Vos équipes en contact client",
        "desc": "ADV, SAV et commerciaux travaillent sur la même vue 360° que le client : plus de recherche dans l'ERP, les e-mails et les tableurs avant de répondre.",
        "advTitle": "ADV",
        "advDesc": "Commandes reçues directement dans le portail, sans ressaisie depuis les e-mails. Suivi des livraisons et des factures impayées.",
        "savTitle": "SAV",
        "savDesc": "Chaque ticket arrive avec le contexte client complet : équipements, révisions, commandes et documents associés.",
        "salesTitle": "Commerciaux",
        "salesDesc": "Devis envoyés, relancés et signés depuis le portail. Visibilité immédiate sur l'activité et les encours de chaque compte."
      }
    },
    "vue360": {
      "badge": "Vue 360°",
      "title": "Une vue 360° de la relation client,\npour vos clients comme pour vos équipes",
      "subtitle": "L'Espace Client rassemble les informations utiles issues de vos différents outils (ERP, CRM, facturation, support) et les présente au bon interlocuteur, au bon moment.",
      "painTitle": "Les problèmes que nous résolvons",
      "pain1Title": "Silos d'information",
      "pain1Desc": "Les données clients sont éparpillées entre ERP, CRM, e-mails et tableurs — personne n'a la vision complète.",
      "pain2Title": "Sollicitations répétées du support",
      "pain2Desc": "« Pouvez-vous me renvoyer cette facture ? » Vos équipes perdent du temps sur des demandes que le client pourrait résoudre seul.",
      "pain3Title": "Manque de visibilité client",
      "pain3Desc": "Vos clients ne voient pas l'état de leurs commandes, devis ou factures — et vos équipes manquent de contexte à chaque demande.",
      "benefitsTitle": "La réponse : une vue 360°",
      "benefit1Title": "Un point d'entrée unique pour vos clients",
      "benefit1Desc": "Factures, commandes, devis, documents et support réunis dans un seul espace à votre marque — une vraie valeur perçue pour le client final.",
      "benefit2Title": "Une vue unifiée pour vos équipes",
      "benefit2Desc": "Lors d'une demande support, vos équipes voient immédiatement les commandes, devis en cours et factures impayées du client — sans changer d'outil.",
      "benefit3Title": "Intégré à vos outils existants",
      "benefit3Desc": "Le portail se connecte à votre ERP/CRM actuel (Dolibarr, Odoo, Salesforce, Sage 100…) — aucune migration, aucune double saisie."
    },
    "features": {
      "title": "Tout ce dont vous avez besoin",
      "subtitle": "Un portail complet pour gérer votre relation avec votre fournisseur, depuis n'importe quel appareil.",
      "invoices": {
        "title": "Factures & Signature électronique",
        "description": "Accédez à toutes vos factures et devis en temps réel. Téléchargement PDF et signature électronique des propositions commerciales."
      },
      "orders": {
        "title": "Commandes & Livraisons",
        "description": "Suivez vos commandes, leur statut de facturation et l'état de vos expéditions directement depuis votre espace."
      },
      "catalog": {
        "title": "Boutique & Catalogue produits",
        "description": "Catalogue produits avec variantes, filtres et images. Boutique publique avec panier et commande en ligne sans compte requis."
      },
      "gallery": {
        "title": "Documents & Galerie",
        "description": "Tous vos documents en un seul endroit : contrats, bons de livraison, attestations. Galerie multimédia intégrée."
      },
      "tickets": {
        "title": "Support & Tickets SAV",
        "description": "Créez et suivez vos demandes de support. Transcription audio automatique pour une saisie rapide des incidents."
      },
      "revisions": {
        "title": "Révisions & Parc d'équipements",
        "description": "Planifiez les révisions périodiques de vos équipements. Suivi individuel de chaque équipement, historique des interventions et rappels automatiques."
      }
    },
    "advantages": {
      "title": "Pourquoi choisir\nl'Espace Client ?",
      "subtitle": "Un portail moderne, sécurisé et pensé pour simplifier vos échanges quotidiens avec votre fournisseur.",
      "secure": "Accès 100% sécurisé (JWT + chiffrement)",
      "realtime": "Données en temps réel depuis votre CRM/ERP",
      "compatible": "Compatible 10+ ERP : Dolibarr, Salesforce, Business Central, Sage 100, NetSuite, Divalto, ERPNext, Zoho One, Cegid et plus",
      "responsive": "Interface responsive — PC, tablette, smartphone",
      "available": "Accessible 24h/24, 7j/7, sans VPN",
      "branded": "Personnalisé à votre marque et vos modules"
    },
    "stats": {
      "invoicesLabel": "Factures disponibles",
      "invoicesValue": "24h/24",
      "setupLabel": "Délai de mise en place",
      "setupValue": "< 1 heure",
      "erpLabel": "CRM/ERP supportés",
      "erpValue": "10+",
      "securityLabel": "Sécurité",
      "securityValue": "Niveau entreprise"
    },
    "erp": {
      "title": "Compatible avec votre CRM/ERP",
      "subtitle": "Connectez votre portail aux principales solutions de gestion du marché en quelques minutes.",
      "dolibarr": "Dolibarr",
      "dolibarrDesc": "ERP open source, version 14+",
      "odoo": "Odoo",
      "odooDesc": "ERP open source, version 16+",
      "salesforce": "Salesforce",
      "salesforceDesc": "CRM & ERP cloud",
      "bc": "Business Central",
      "bcDesc": "Microsoft ERP cloud",
      "csv": "CSV / Excel",
      "csvDesc": "Import de fichiers plats"
    },
    "payment": {
      "badge": "Nouveau — Paiement en ligne",
      "title": "Vos clients paient leurs factures\nen quelques clics",
      "subtitle": "Vos clients règlent leurs factures directement depuis le portail, par carte bancaire. Les fonds sont virés automatiquement sur votre compte — sans relance, sans suivi manuel.",
      "step1Title": "Le client clique « Payer »",
      "step1Desc": "Sur n'importe quelle facture impayée, un bouton de paiement apparaît directement dans l'espace client.",
      "step2Title": "Paiement sécurisé en ligne",
      "step2Desc": "Carte bancaire. La transaction est chiffrée et protégée par 3D Secure — aucune donnée bancaire stockée sur le portail.",
      "step3Title": "Virement SEPA sur votre compte",
      "step3Desc": "Les fonds sont virés directement sur votre IBAN. Vous encaissez sans intervention manuelle.",
      "trust": "Paiement 100% sécurisé",
      "trustSub": "Chiffrement bancaire, 3D Secure, conformité PCI-DSS",
      "recurring": "Paiements récurrents disponibles",
      "onboarding": "Activation rapide — coordonnées bancaires en une seule fois",
      "noFees": "Aucun frais fixe — commission uniquement sur les transactions"
    },
    "aiAssistant": {
      "badge": "Nouveau — Assistant IA",
      "title": "Un assistant IA qui guide vos clients\nvers le bon produit",
      "subtitle": "Dans la boutique publique comme dans le catalogue client, vos clients décrivent leur besoin — par écrit ou à la voix — et l'IA n'affiche que les produits correspondants.",
      "chatTitle": "Chatbot intelligent",
      "chatDesc": "« Je cherche un casque sans fil à moins de 100 € » : la demande est interprétée par l'IA et le catalogue se filtre instantanément sur les produits pertinents.",
      "voiceTitle": "Voice bot intégré",
      "voiceDesc": "Vos clients parlent, l'assistant écoute, comprend et répond à voix haute. Idéal sur mobile ou en situation de mobilité.",
      "catalogTitle": "Connecté à votre catalogue",
      "catalogDesc": "L'assistant interroge en direct la base produits de votre ERP : prix, descriptions et stocks toujours à jour, sans configuration supplémentaire."
    },
    "howItWorks": {
      "title": "Opérationnel en quelques minutes",
      "step1": {
        "title": "Configurez votre ERP",
        "desc": "Renseignez l'URL et la clé API de votre CRM/ERP. La connexion est testée automatiquement."
      },
      "step2": {
        "title": "Invitez vos clients",
        "desc": "Créez les comptes de vos clients ou laissez-les faire une demande d'accès via le portail."
      },
      "step3": {
        "title": "Vos clients accèdent",
        "desc": "Factures, commandes, devis, support — tout est disponible 24h/24 sans intervention de votre part."
      }
    },
    "useCases": {
      "badge": "Cas d'usage",
      "title": "Ce que vos clients et vos équipes\nfont concrètement avec Espace Client",
      "subtitle": "Quel que soit votre secteur, le portail s'adapte à vos flux existants — sans migration ni double saisie. Voici six situations fréquentes.",
      "contextLabel": "Avant",
      "resultLabel": "Avec Espace Client",
      "uc1": {
        "title": "Distribution & négoce B2B",
        "context": "Vos clients recommandent en boucle les mêmes références et appellent l'ADV pour connaître l'état de leurs commandes.",
        "result": "Ils recommandent en un clic depuis leur historique, suivent leurs livraisons en temps réel et règlent leurs factures en ligne — les appels à l'ADV chutent."
      },
      "uc2": {
        "title": "Artisans & BTP",
        "context": "Vos devis attendent des jours une signature papier renvoyée par courrier ou par scan.",
        "result": "Le client signe le devis électroniquement depuis son mobile et retrouve bons de livraison et attestations dans un espace dédié à son chantier."
      },
      "uc3": {
        "title": "Maintenance & SAV d'équipements",
        "context": "Les révisions périodiques se ratent et les demandes de SAV se perdent dans les e-mails.",
        "result": "Chaque équipement a sa fiche, ses rappels de révision automatiques et un ticket SAV suivi de bout en bout."
      },
      "uc4": {
        "title": "Services & abonnements récurrents",
        "context": "Vous relancez chaque mois les mêmes clients pour des factures récurrentes impayées.",
        "result": "Paiement en ligne par carte ou SEPA et rappels d'échéance automatiques : le délai de règlement se réduit sans effort."
      },
      "uc5": {
        "title": "Industrie & fournisseurs grands comptes",
        "context": "Vos clients réclament un portail mais vous ne voulez ni re-saisir vos données ERP ni gérer un projet lourd.",
        "result": "Le portail lit commandes, livraisons et factures en direct dans l'ERP et gère la facture électronique (PA/PDP) pour la réforme 2026."
      },
      "uc6": {
        "title": "E-commerce B2B piloté par l'ERP",
        "context": "Votre catalogue vit dans l'ERP mais vos clients n'ont aucun moyen de commander en self-service.",
        "result": "Boutique publique à votre marque, commande invité sans compte, et un assistant IA (chat + voix) qui trouve le bon produit à partir du besoin décrit."
      }
    },
    "faq": {
      "badge": "FAQ",
      "title": "Questions fréquentes",
      "subtitle": "L'essentiel sur Espace Client, sa compatibilité ERP et sa mise en place.",
      "q1": {
        "q": "Qu'est-ce qu'Espace Client ?",
        "a": "Espace Client est un portail client SaaS qui se connecte en temps réel à votre ERP ou CRM existant. Vos clients y consultent factures, commandes, devis et documents, paient en ligne et signent leurs devis dans un espace unique à votre marque. Vos équipes ADV, SAV et commerciales partagent la même vue 360°."
      },
      "q2": {
        "q": "Avec quels ERP ou CRM est-il compatible ?",
        "a": "Le portail est agnostique de l'ERP grâce à un système d'adaptateurs : Dolibarr, Odoo, Salesforce, Microsoft Business Central, Sage 100, NetSuite, Divalto Infinity, ERPNext, Zoho One, Cegid XRP Flex, ou un simple import CSV/Excel."
      },
      "q3": {
        "q": "Dois-je migrer mes données ?",
        "a": "Non. Aucune migration : Espace Client lit et écrit les données directement dans votre ERP existant. Vous continuez à travailler dans votre outil habituel."
      },
      "q4": {
        "q": "Combien coûte Espace Client ?",
        "a": "Les packs démarrent à 9 € HT/mois (Starter : 1 utilisateur, 50 clients), puis 49 € (Pro) et 99 € (Gold : 10 utilisateurs, 1 000 clients). Une offre Entreprise sur devis propose des quotas sur mesure, et plusieurs packs peuvent être cumulés."
      },
      "q5": {
        "q": "Mes clients peuvent-ils payer leurs factures en ligne ?",
        "a": "Oui, par carte bancaire (3D Secure) ou virement SEPA. Le règlement est rapproché automatiquement et des rappels d'échéance partent seuls pour réduire vos retards de paiement."
      },
      "q6": {
        "q": "La signature électronique des devis est-elle valable ?",
        "a": "Oui. Les devis sont signés électroniquement en ligne via des prestataires conformes au règlement eIDAS ; le PDF signé est archivé et le statut est remonté automatiquement dans votre ERP."
      },
      "q7": {
        "q": "Est-ce compatible avec la facture électronique 2026 en France ?",
        "a": "Oui. Espace Client intègre des connecteurs PA/PDP (Plateforme Agréée) pour la réforme française de la facturation électronique, avec suivi des soumissions."
      },
      "q8": {
        "q": "Combien de temps faut-il pour mettre en place le portail ?",
        "a": "Quelques minutes : vous renseignez l'URL et la clé API de votre ERP, la connexion est testée, puis vous invitez vos clients ou les laissez demander un accès. Le portail est ensuite disponible 24h/24 sans intervention."
      }
    },
    "pricing": {
      "navLink": "Tarifs",
      "badge": "Tarifs",
      "title": "Des packs clairs, sans surprise",
      "subtitle": "Choisissez le pack adapté à votre activité. Achetez plusieurs packs pour multiplier vos quotas proportionnellement.",
      "onQuote": "Sur devis",
      "customQuotas": "Quotas personnalisés",
      "customValue": "Sur mesure",
      "contactUs": "Nous contacter",
      "popular": "Populaire",
      "perMonth": "/mois",
      "billingMultiple": "HT · {{count}} packs × {{price}} €",
      "billingMonthly": "HT · facturation mensuelle",
      "packCount": "Nombre de packs",
      "start": "Commencer",
      "creditsBuyNote": "Quota épuisé ? Achetez des crédits supplémentaires à tout moment depuis votre espace d'administration : ils complètent vos quotas mensuels (emails, signatures, tokens IA…) sans changer de pack.",
      "creditsNote": "Règle de crédits : 1 € = 1 000 crédits. Les crédits alimentent l'usage des emails, signatures, tokens IA, etc.",
      "quota": {
        "users": "Utilisateurs",
        "clients": "Clients",
        "signatures": "Signatures",
        "aiTokens": "Tokens IA",
        "emails": "Emails/mois",
        "catalog": "Produits boutique"
      }
    },
    "cta": {
      "title": "Prêt à accéder à votre espace ?",
      "subtitle": "Connectez-vous avec vos identifiants pour accéder à votre espace personnalisé.",
      "button": "Se connecter à mon espace",
      "registerButton": "Faire une demande d'accès",
      "registerHint": "Vous n'avez pas encore de compte ? Soumettez une demande d'inscription, votre fournisseur vous donnera accès."
    },
    "footer": "Espace client — Votre portail de gestion sécurisé",
    "footerService": "Un service Iseffi —"
  },
  "seo": {
    "landingTitle": "Espace Client — Portail client pour vos clients et vos équipes ADV, SAV et commerciales",
    "landingDescription": "Portail client connecté à votre ERP/CRM (Dolibarr, Odoo, Salesforce…) : un espace unique pour vos clients finaux et pour vos équipes ADV, SAV et commerciales — factures, commandes, devis, paiement en ligne, signature électronique et support.",
    "loginTitle": "Connexion — Espace Client",
    "registerTitle": "Demande d'accès — Espace Client",
    "shopTitle": "Boutique en ligne — Espace Client",
    "shopTitleWithName": "Boutique {{name}} — Espace Client"
  },
  "shopAssistant": {
    "button": "Assistant IA",
    "buttonTitle": "Rechercher des produits avec l'assistant IA",
    "title": "Assistant boutique",
    "subtitle": "Décrivez ce que vous cherchez",
    "listening": "Je vous écoute…",
    "welcome": "Bonjour ! Décrivez-moi ce que vous cherchez (par écrit ou à la voix) et je vous affiche les produits correspondants.",
    "placeholder": "Ex. : un casque sans fil à moins de 100 €",
    "found_one": "J'ai trouvé {{count}} produit correspondant à votre recherche. Il est affiché dans la page.",
    "found_other": "J'ai trouvé {{count}} produits correspondant à votre recherche. Ils sont affichés dans la page.",
    "notFound": "Je n'ai trouvé aucun produit correspondant. Essayez de reformuler votre demande.",
    "error": "Désolé, une erreur est survenue. Veuillez réessayer.",
    "cleared": "Très bien, j'affiche à nouveau tout le catalogue.",
    "showAll": "Afficher tous les produits",
    "activeFilter_one": "Filtre IA actif — {{count}} produit affiché",
    "activeFilter_other": "Filtre IA actif — {{count}} produits affichés",
    "voiceOn": "Activer le mode vocal (écoute + réponse parlée)",
    "voiceOff": "Désactiver le mode vocal",
    "speak": "Parler",
    "stopListening": "Arrêter l'écoute",
    "send": "Envoyer"
  },
  "clientSwitcher": {
    "searchPlaceholder": "Rechercher un client…",
    "typeMore": "Saisissez au moins 2 caractères…",
    "searching": "Recherche en cours…",
    "noResults": "Aucun client trouvé",
    "viewingAs": "Vue en tant que :",
    "exitClient": "Quitter ce client"
  },
  "pagination": {
    "show": "Afficher",
    "perPage": "par page",
    "showing": "{{from}}-{{to}} sur {{total}}",
    "noResults": "Aucun résultat",
    "previous": "Page précédente",
    "next": "Page suivante"
  },
  "darkMode": {
    "toggle": "Basculer le mode sombre"
  },
  "myTeam": {
    "title": "Mon équipe",
    "subtitle": "Gérez les utilisateurs de votre entreprise",
    "inviteUser": "Inviter un utilisateur",
    "colName": "Nom",
    "colEmail": "Email",
    "colRole": "Rôle",
    "colStatus": "Statut",
    "colLastLogin": "Dernière connexion",
    "colActions": "Actions",
    "roleUser": "Utilisateur",
    "roleAdmin": "Administrateur",
    "statusActive": "Actif",
    "statusInactive": "Inactif",
    "deactivate": "Désactiver",
    "activate": "Réactiver",
    "firstname": "Prénom",
    "lastname": "Nom",
    "phone": "Téléphone",
    "inviteNote": "Un email sera envoyé avec un mot de passe temporaire.",
    "noUsers": "Aucun utilisateur dans votre équipe.",
    "loadError": "Impossible de charger les utilisateurs.",
    "inviteError": "Erreur lors de l'invitation.",
    "toggleError": "Erreur lors de la mise à jour du statut.",
    "updateError": "Erreur lors de la mise à jour.",
    "emailRequired": "L'email est requis.",
    "roleConfirmTitle": "Retrait du rôle administrateur",
    "roleConfirmMessage": "Confirmez-vous le retrait du rôle administrateur pour {{user}} ?",
    "lastAdminTitle": "Action impossible",
    "lastAdminError": "Impossible de retirer le rôle administrateur : {{user}} est le dernier administrateur de l'équipe."
  },
  "adminProducts": {
    "title": "Catalogue produits",
    "count": "{{count}} produit(s)",
    "noProducts": "Aucun produit trouvé."
  },
  "parc": {
    "title": "Parc d'équipements",
    "tabSchedules": "Échéances",
    "tabParc": "Parc",
    "colLabel": "Désignation",
    "colSerial": "N° série",
    "colPurchase": "Date achat",
    "colLastRevision": "Dernière révision",
    "colNextRevision": "Prochaine échéance",
    "colStatus": "Statut",
    "statusActive": "Actif",
    "statusEndOfLife": "Fin de vie",
    "statusRetired": "Réformé",
    "revise": "Enregistrer une révision",
    "revisionDate": "Date de révision",
    "revisionNotes": "Observations",
    "history": "Historique des révisions",
    "noHistory": "Aucune révision enregistrée.",
    "noEquipment": "Aucun équipement dans votre parc.",
    "addEquipment": "Ajouter un équipement",
    "editEquipment": "Modifier l'équipement",
    "loadError": "Impossible de charger le parc.",
    "reviseError": "Erreur lors de l'enregistrement de la révision.",
    "ruleAndCustomerRequired": "La règle de révision et le client sont requis."
  },
  "adminUsage": {
    "title": "Consommation",
    "subtitle": "Suivi des usages par type et par fournisseur",
    "dashboardHint": "Signatures, emails, tokens IA — vue mensuelle",
    "months": "mois",
    "tabGlobal": "Vue globale",
    "tabByErp": "Par fournisseur",
    "chartTitle": "Évolution mensuelle",
    "noData": "Aucune donnée sur la période sélectionnée.",
    "supplier": "Fournisseur",
    "esignature": "Signatures électroniques",
    "email": "Emails envoyés",
    "aiTokensClaude": "Tokens Claude IA",
    "aiTokensVapi": "Appels Vapi (voix)"
  },
  "payment": {
    "pay": "Payer",
    "paid": "Payé",
    "error": "Erreur lors de la création du paiement.",
    "confirm": "Confirmer le paiement",
    "modalTitle": "Paiement sécurisé",
    "modalDesc": "Facture",
    "myPaymentsTitle": "Mes paiements",
    "myPaymentsSubtitle": "Historique de vos paiements de factures",
    "noPayments": "Aucun paiement enregistré.",
    "invoiceRef": "Facture",
    "amount": "Montant",
    "type": "Type",
    "status": "Statut",
    "date": "Date",
    "typeOneTime": "Ponctuel",
    "typeSubscription": "Récurrent",
    "statusSucceeded": "Payé",
    "statusFailed": "Échoué",
    "statusCancelled": "Annulé",
    "statusPending": "En attente",
    "statusRefunded": "Remboursé"
  },
  "migration": {
    "title": "Migration ERP — Export / Import CSV",
    "subtitle": "Exportez les données d'un ERP au format CSV pivot, puis importez-les dans un autre ERP. Le format CSV est lisible et éditable dans Excel.",
    "modules": "Modules disponibles",
    "module_label": "Module",
    "col": {
      "module": "Module",
      "description": "Description",
      "capabilities": "Capacités"
    },
    "template": {
      "title": "Télécharger un modèle CSV vide",
      "help": "Le modèle contient les en-têtes et une ligne d'exemple pour vous guider lors de la saisie dans Excel.",
      "btn": "Télécharger le modèle"
    },
    "export": {
      "title": "Exporter les données d'un ERP",
      "btn": "Exporter en CSV"
    },
    "import": {
      "title": "Importer des données dans un ERP",
      "none": "Aucun module ne supporte l'import dans cette version.",
      "destination": "(destination)",
      "file": "Fichier CSV",
      "btn": "Importer",
      "choose": "Choisir un fichier...",
      "rows": "lignes importées",
      "created": "créés",
      "updated": "mis à jour",
      "skipped": "ignorés",
      "warnings": "avertissements",
      "done": "Import terminé"
    }
  },
  "status": {
    "common": {
      "unknown": "Inconnu"
    },
    "invoice": {
      "paid": "Payée",
      "draft": "Brouillon",
      "validated": "Validée",
      "abandoned": "Abandonnée",
      "cancelled": "Annulée",
      "late": "En retard"
    },
    "order": {
      "draft": "Brouillon",
      "validated": "Validée",
      "shipment_in_progress": "Expédition en cours",
      "shipped": "Expédiée",
      "cancelled": "Annulée"
    },
    "shipment": {
      "draft": "Brouillon",
      "validated": "Validée",
      "closed": "Clôturée",
      "cancelled": "Annulée"
    },
    "ticket": {
      "not_read": "Non lu",
      "read": "Lu",
      "assigned": "Assigné",
      "in_progress": "En cours",
      "waiting": "En attente",
      "need_more_info": "Besoin d'info",
      "resolved": "Résolu",
      "closed": "Fermé",
      "cancelled": "Annulé"
    }
  },
  "admin.erps.stripeTitle": "Paiement en ligne (Stripe)",
  "admin.erps.stripeHint": "Permet aux clients de payer leurs factures depuis le portail.",
  "admin.erps.stripeEnabled": "Activer le paiement Stripe",
  "admin.erps.stripePublishableKey": "Clé publique (pk_...)",
  "admin.erps.stripeSecretKey": "Clé secrète (sk_...)",
  "admin.erps.stripeWebhookSecret": "Webhook secret (whsec_...)",
  "admin.erps.stripeCurrency": "Devise",
  "admin.erps.stripeRecurring": "Activer paiements récurrents",
  "adminBilling": {
    "title": "Abonnements & Facturation",
    "subtitle": "Configuration des plans tarifaires par pack et gestion des abonnements ERP",
    "tabs": {
      "plans": "Plans d'abonnement",
      "erps": "Abonnements ERP",
      "costs": "Coûts des crédits"
    },
    "status": {
      "active": "Actif",
      "inactive": "Inactif"
    },
    "quota": {
      "users": "Utilisateurs",
      "clients": "Clients",
      "signatures": "Signatures",
      "aiTokens": "Tokens IA",
      "emails": "Emails",
      "catalogProducts": "Produits boutique",
      "custom": "Sur mesure"
    },
    "planForm": {
      "titleNew": "Nouveau plan",
      "titleEdit": "Modifier — {{name}}",
      "nameRequired": "Le nom est requis.",
      "savingError": "Erreur lors de la sauvegarde.",
      "name": "Nom *",
      "descriptionFr": "Description (FR)",
      "descriptionEn": "Description (EN)",
      "customPlan": "Plan sur devis (quotas sur mesure)",
      "priceLabel": "Prix / pack / mois (€)",
      "statusLabel": "Statut",
      "statusActive": "Actif",
      "statusInactive": "Inactif",
      "usersPerPack": "Utilisateurs / pack",
      "clientsPerPack": "Clients / pack",
      "signaturesPerPack": "Signatures / pack",
      "aiTokensPerPack": "Tokens IA / pack",
      "emailsPerPack": "Emails / pack",
      "catalogPerPack": "Produits boutique / pack",
      "featuresLabel": "Fonctionnalités incluses",
      "featuresHint": "(une par ligne)",
      "featuresPlaceholder": "Support prioritaire\nAccès API\nRapports avancés",
      "cancel": "Annuler",
      "create": "Créer",
      "save": "Enregistrer"
    },
    "addCredits": {
      "title": "Crédits — {{name}}",
      "invalidAmount": "Montant invalide.",
      "genericError": "Erreur.",
      "amountLabel": "Montant (€)",
      "reasonLabel": "Motif (optionnel)",
      "reasonPlaceholder": "Ajout manuel par l'administrateur",
      "cancel": "Annuler",
      "add": "Ajouter"
    },
    "assignPlan": {
      "title": "Abonnement — {{name}}",
      "choosePlanRequired": "Veuillez choisir un plan.",
      "quantityMin": "La quantité doit être ≥ 1.",
      "genericError": "Erreur.",
      "planLabel": "Plan",
      "choosePlanOption": "-- Choisir un plan --",
      "onQuote": "sur devis",
      "packsLabel": "Nombre de packs",
      "monthlyTotal": "Total mensuel :",
      "effectiveQuotas": "Quotas effectifs",
      "cancel": "Annuler",
      "activate": "Activer"
    },
    "plansTab": {
      "newPlan": "Nouveau plan",
      "onQuote": "Sur devis",
      "perPackPerMonth": "/pack/mois",
      "edit": "Modifier",
      "deactivate": "Désactiver",
      "confirmDeactivate": "Désactiver le plan \"{{name}}\" ?",
      "deactivateError": "Erreur lors de la désactivation.",
      "noPlans": "Aucun plan configuré."
    },
    "erpsTab": {
      "refresh": "Actualiser",
      "totalErps": "ERP total",
      "availableCredits": "Crédits disponibles",
      "monthlyValue": "Valeur mensuelle totale",
      "statusLabel": "Statut",
      "nextBilling": "Prochaine facturation",
      "creditBalance": "Solde crédits",
      "purchasedPacks": "Packs achetés",
      "customValue": "Sur mesure",
      "effectiveQuotas": "Quotas effectifs",
      "changePlan": "Changer de plan",
      "addCredits": "Ajouter des crédits",
      "noErps": "Aucun ERP avec abonnement trouvé."
    },
    "costsTab": {
      "description": "Nombre de crédits débités par unité consommée. Règle de conversion : <strong>1 € = 1 000 crédits</strong>.",
      "colResource": "Ressource",
      "colCreditsPerUnit": "Crédits / unité",
      "colUnitsPerBilling": "Unités / facturation",
      "colActive": "Actif",
      "noCosts": "Aucun coût configuré.",
      "saveCosts": "Enregistrer les coûts"
    },
    "resources": {
      "smtp_email": "Email (SMTP)",
      "sms": "SMS",
      "esignature": "Signature électronique",
      "ai_tokens_claude": "Tokens IA Claude",
      "ai_tokens_vapi": "Appels Vapi (voix)",
      "document_storage": "Stockage documents",
      "api_calls": "Appels API"
    }
  },
  "adminProfile": {
    "title": "Fiche fournisseur",
    "subtitle": "Informations de votre société",
    "loadError": "Impossible de charger le profil.",
    "saveError": "Erreur lors de la sauvegarde.",
    "saveSuccess": "Profil sauvegardé.",
    "save": "Enregistrer",
    "saving": "Sauvegarde…",
    "sectionCompany": "Société",
    "erpName": "Nom de la société",
    "description": "Description",
    "siren": "SIREN",
    "website": "Site web",
    "sectionAddress": "Adresse postale",
    "address": "Adresse",
    "postalCode": "Code postal",
    "city": "Ville",
    "countryCode": "Pays (code)",
    "sectionContact": "Contact",
    "contactEmail": "Email de contact",
    "contactPhone": "Téléphone"
  },
  "apiErrors": {
    "userNotLinkedToErp": "Utilisateur non lié à un ERP.",
    "pleaseSelectClient": "Veuillez sélectionner un client.",
    "noClientLinked": "Aucun client associé à ce compte.",
    "routeNotFound": "Page introuvable.",
    "erpConnectionError": "Erreur de connexion à l'ERP.",
    "serverError": "Une erreur serveur est survenue.",
    "connectionError": "Erreur de connexion. Veuillez réessayer.",
    "stripeConnectionError": "Erreur lors de la connexion Stripe.",
    "unexpectedResponse": "Réponse inattendue du serveur.",
    "unknown": "Une erreur inattendue est survenue."
  },
  "adminHelpTooltips": {
    "title": "Bulles d'aide",
    "configTitle": "Configuration des bulles d'aide",
    "comingSoon": "Cette fonctionnalité sera disponible prochainement.",
    "pageTitle": "Aide à la configuration",
    "subtitleSuperAdmin": "Guides de connexion pour tous les ERP et utilisation de l'espace client",
    "subtitleAdmin": "Guides d'utilisation de votre espace client",
    "sectionErpLabel": "Connexion à l'ERP",
    "sectionUsageLabel": "Utilisation de l'espace client",
    "badgeComingSoon": "À venir",
    "officialDoc": "Documentation officielle →",
    "footerNote": "Des sections supplémentaires (gestion des utilisateurs, catalogue, tickets…) seront ajoutées prochainement. En cas de problème de connexion, vérifiez que votre ERP est accessible depuis l'extérieur et que l'utilisateur API dispose bien des droits de lecture.",
    "categories": {
      "erp": {
        "title": "Connexion à votre ERP",
        "description": "Prérequis et étapes pour connecter votre ERP à l'espace client"
      },
      "users": {
        "title": "Gestion des utilisateurs",
        "description": "Inviter, configurer et gérer les accès de vos clients"
      },
      "invoices": {
        "title": "Factures et commandes",
        "description": "Comprendre l'affichage et les statuts des documents"
      },
      "catalog": {
        "title": "Catalogue et boutique",
        "description": "Configurer le catalogue produits et la boutique en ligne"
      },
      "tickets": {
        "title": "Tickets et support",
        "description": "Paramétrer le module de support client"
      }
    },
    "erps": {
      "dolibarr": {
        "tip": "Le portail ajoute automatiquement /api/index.php à toutes les requêtes — ne l'incluez pas dans l'URL de base.",
        "steps": [
          {
            "title": "Activer le module API REST",
            "content": "Dans Dolibarr, allez dans Accueil → Configuration → Modules / Applications → Interface. Activez le module \"API / Webservices\" (REST)."
          },
          {
            "title": "Activer les modules métiers nécessaires",
            "content": "Activez les modules correspondant aux fonctionnalités souhaitées dans l'espace client : Factures clients, Commandes, Expéditions, Produits/Services, Tiers, Tickets/SAV selon les modules activés dans votre portail."
          },
          {
            "title": "Créer un utilisateur dédié à l'API",
            "content": "Allez dans Accueil → Configuration → Utilisateurs et groupes → Nouvel utilisateur. Créez un compte dédié (ex. \"api-portail\"). Cela évite de lier l'API à un compte personnel."
          },
          {
            "title": "Générer la clé API (DOLAPIKEY)",
            "content": "Ouvrez le profil de cet utilisateur, puis cliquez sur l'onglet \"API / Webservices\". Cliquez sur \"Générer/régénérer la clé API externe\". Copiez la clé générée — c'est votre DOLAPIKEY.",
            "code": "DOLAPIKEY"
          },
          {
            "title": "Attribuer les droits de lecture",
            "content": "Dans le profil de l'utilisateur, onglet \"Droits\", assurez-vous qu'il a les droits de lecture sur chaque module activé : Tiers (lecture), Factures (lecture), Commandes (lecture), Produits (lecture), Expéditions (lecture), Tickets (lecture)."
          },
          {
            "title": "Configurer la connexion dans le portail",
            "content": "Renseignez l'URL de base de votre instance Dolibarr (ex. https://mon-dolibarr.example.com) et la clé API générée. Cliquez sur \"Tester la connexion\" pour valider.",
            "code": "https://mon-dolibarr.example.com"
          }
        ]
      },
      "odoo": {
        "tip": "Avec Odoo, l'identifiant (login) de l'utilisateur sert de \"clé API\" et le mot de passe API généré remplace le mot de passe habituel.",
        "steps": [
          {
            "title": "Créer un utilisateur technique dédié",
            "content": "Dans Odoo, allez dans Paramètres → Utilisateurs & Entreprises → Utilisateurs. Créez un utilisateur dédié (ex. \"api-portail\") avec un accès de type \"Utilisateur interne\"."
          },
          {
            "title": "Activer l'accès aux applications nécessaires",
            "content": "Dans le profil de cet utilisateur, accordez l'accès aux applications utilisées : Ventes (commandes, devis), Comptabilité (factures), Inventaire (expéditions), Service d'assistance (tickets), Achats selon vos besoins."
          },
          {
            "title": "Générer une clé API",
            "content": "Ouvrez le profil de l'utilisateur → Préférences (icône en haut à droite) → section \"API\". Cliquez sur \"Nouvelle clé API\", donnez-lui un nom (ex. \"portail-client\"), copiez la clé générée — elle ne sera affichée qu'une seule fois."
          },
          {
            "title": "Configurer la connexion dans le portail",
            "content": "Renseignez l'URL de base de votre instance Odoo (ex. https://monentreprise.odoo.com), l'identifiant de connexion de l'utilisateur technique, et la clé API comme mot de passe.",
            "code": "https://monentreprise.odoo.com"
          }
        ]
      },
      "bleez": {
        "tip": "Bleez utilise OAuth 2.0 Client Credentials — un flux machine-to-machine sans intervention utilisateur. Le Client ID et le Client Secret ainsi que le numéro de dossier encryptée sont nécessaires.",
        "steps": [
          {
            "title": "Récupérer le Client ID et Client Secret",
            "context": "Sur le support de Bleez, demander l'accès aux informations du client_id et le client secret"
          },
          {
            "title": "Récupérer le numéro de dossier",
            "context": "Dans Bleez, allez dans 'Administration' dans le menu de navigation, puis 'Dossier' et pour finir 'Paramétrage'."
          },
          {
            "title": "Renseigner les informations dans le portail",
            "content": "Renseignez le Client ID (Clé API), le Client Secret (Secret API) et le numéro de dossier. Indiquez également les informations du compte de connexion à Bleez."
          }
        ]
      },
      "salesforce": {
        "tip": "Salesforce utilise OAuth 2.0 Client Credentials — un flux machine-to-machine sans intervention utilisateur. Seuls le Client ID et le Client Secret sont nécessaires, configurés via une External Client App.",
        "steps": [
          {
            "title": "Créer une External Client App",
            "content": "Dans Salesforce, allez dans Configuration (Setup) → recherchez \"External Client App Manager\". Cliquez sur \"New External Client App\". Renseignez le nom de l'app et l'email de contact."
          },
          {
            "title": "Configurer OAuth et activer Client Credentials",
            "content": "Dans les paramètres OAuth de l'app, ajoutez le scope \"api\". Activez ensuite \"Enable Client Credentials Flow\". Dans le champ \"Run As\", sélectionnez l'utilisateur technique qui effectuera les appels API (il doit avoir les droits sur les objets Salesforce utilisés)."
          },
          {
            "title": "Récupérer le Client ID et Client Secret",
            "content": "Sauvegardez l'app et attendez quelques minutes (propagation Salesforce). Revenez sur la fiche : le Client ID (Consumer Key) va dans le champ \"Client ID\" du portail, le Client Secret dans \"Client Secret\"."
          },
          {
            "title": "Vérifier les droits de l'utilisateur \"Run As\"",
            "content": "L'utilisateur désigné dans \"Run As\" doit avoir accès aux objets nécessaires : Account (clients), Case (tickets), et selon vos modules : Order (commandes), Invoice (factures). Vérifiez via Setup → Profiles ou Permission Sets."
          },
          {
            "title": "Renseigner l'Instance URL et la version API",
            "content": "L'Instance URL correspond à l'URL de votre org Salesforce. Pour une Developer Edition, elle ressemble à https://orgfarm-XXXXXXXX-dev-ed.develop.my.salesforce.com. La version API recommandée est v59.0 ou supérieure.",
            "code": "https://orgfarm-XXXXXXXX-dev-ed.develop.my.salesforce.com"
          },
          {
            "title": "Identifier vos clients et tickets Salesforce",
            "content": "Chaque client du portail correspond à un Account Salesforce (ID format 001XXXXXXXXXXXX, visible dans l'URL de la fiche Account). Les tickets correspondent aux Cases Salesforce (ID format 5004XXXXXXXXXXXX). Ces identifiants sont utilisés pour récupérer les données via l'API."
          }
        ]
      },
      "business_central": {
        "tip": "Business Central utilise OAuth 2.0 via Azure AD. Vous aurez besoin du Tenant ID, de l'Environment Name et de l'ID entreprise (Company ID).",
        "steps": [
          {
            "title": "Enregistrer une application dans Azure AD",
            "content": "Dans le portail Azure (portal.azure.com), allez dans Azure Active Directory → Inscriptions d'applications → Nouvelle inscription. Nommez l'application (ex. \"portail-client-bc\") et notez l'Application (client) ID et le Directory (tenant) ID."
          },
          {
            "title": "Créer un secret client",
            "content": "Dans la fiche de l'application Azure AD → Certificats et secrets → Nouveau secret client. Donnez-lui une durée (12 ou 24 mois). Copiez immédiatement la valeur du secret — elle disparaît après fermeture."
          },
          {
            "title": "Accorder les permissions API",
            "content": "Dans Autorisations API → Ajouter une autorisation → Dynamics 365 Business Central → Application permissions. Ajoutez \"API.ReadWrite.All\" ou les permissions plus fines (Financials, Sales, etc.). Cliquez sur \"Accorder le consentement administrateur\"."
          },
          {
            "title": "Récupérer l'Environment et Company ID",
            "content": "Dans Business Central, allez dans l'environnement cible. L'URL contient ces informations : https://api.businesscentral.dynamics.com/v2.0/{tenant_id}/{environment_name}/api/... Notez également l'ID de la société (Company ID) visible dans Administration."
          },
          {
            "title": "Configurer la connexion dans le portail",
            "content": "Renseignez le Tenant ID, l'Environment Name (ex. \"Production\"), le Company ID, le Client ID (Application ID Azure) et le Client Secret."
          }
        ]
      },
      "sage100": {
        "tip": "Sage 100 nécessite l'installation et la configuration du connecteur API Sage sur votre serveur. Contactez votre partenaire Sage si nécessaire.",
        "steps": [
          {
            "title": "Vérifier la version et le connecteur API",
            "content": "La connexion API nécessite Sage 100 v7.0+ et le module API REST Sage (ou un connecteur tiers). Vérifiez que votre licence inclut l'accès API et que le service est démarré sur le serveur."
          },
          {
            "title": "Configurer les autorisations utilisateur",
            "content": "Dans Sage 100, créez ou désignez un utilisateur technique avec les droits de lecture sur les dossiers comptables, ventes, achats et stocks selon les modules activés dans votre portail."
          },
          {
            "title": "Générer les identifiants API",
            "content": "Dans la console d'administration Sage 100, configurez l'authentification API (Basic Auth ou Token selon votre version). Notez l'URL du serveur API, le login et le mot de passe de l'utilisateur technique."
          },
          {
            "title": "Configurer la connexion dans le portail",
            "content": "Renseignez l'URL de base du serveur API Sage 100, la clé API (ou login) et le secret (ou mot de passe). Assurez-vous que le serveur est accessible depuis l'hébergement du portail."
          }
        ]
      },
      "netsuite": {
        "tip": "NetSuite utilise OAuth 1.0 avec 4 clés : Consumer Key, Consumer Secret, Token ID, Token Secret. Toutes sont nécessaires.",
        "steps": [
          {
            "title": "Activer les fonctionnalités REST",
            "content": "Dans NetSuite, allez dans Configuration → Entreprise → Fonctionnalités. Dans l'onglet \"SuiteCloud\", activez \"REST Web Services\" et \"Token-Based Authentication (TBA)\"."
          },
          {
            "title": "Créer une intégration (application)",
            "content": "Allez dans Configuration → Intégration → Gérer les intégrations → Nouvelle. Nommez-la (ex. \"portail-client\"), activez \"Token-Based Authentication\". Sauvegardez et notez le Consumer Key et Consumer Secret affichés une seule fois."
          },
          {
            "title": "Créer un rôle API dédié",
            "content": "Dans Configuration → Utilisateurs/Rôles → Gérer les rôles → Nouveau rôle. Accordez les droits de lecture sur les listes et transactions nécessaires (Clients, Factures, Commandes, Articles). Activez \"API uniquement\" pour ce rôle."
          },
          {
            "title": "Créer un Token d'accès",
            "content": "Allez dans Configuration → Utilisateurs/Rôles → Jetons d'accès → Nouveau. Sélectionnez l'application créée, l'utilisateur technique et le rôle API. Sauvegardez et notez le Token ID et Token Secret — affichés une seule fois."
          },
          {
            "title": "Configurer la connexion dans le portail",
            "content": "Renseignez l'URL de votre instance NetSuite, le Consumer Key, Consumer Secret, Token ID et Token Secret. L'Account ID NetSuite est visible dans Administration → Informations sur le compte."
          }
        ]
      },
      "divalto": {
        "tip": "Divalto Infinity expose une API REST native. Votre partenaire Divalto peut vous aider à configurer les droits d'accès sur les domaines métiers.",
        "steps": [
          {
            "title": "Vérifier l'activation de l'API REST",
            "content": "Dans Divalto Infinity, vérifiez que le serveur d'API REST est actif et accessible. Cette configuration est généralement réalisée par votre partenaire Divalto lors du déploiement."
          },
          {
            "title": "Créer un utilisateur technique",
            "content": "Créez un utilisateur dédié dans Divalto avec un profil restreint aux lectures des domaines nécessaires : Tiers, Commandes, Factures, Stocks selon vos modules activés."
          },
          {
            "title": "Configurer les droits d'accès API",
            "content": "Dans la console d'administration Divalto, activez l'accès API pour cet utilisateur et accordez les droits de lecture sur les domaines métiers (Ventes, Achats, Comptabilité, Stock)."
          },
          {
            "title": "Configurer la connexion dans le portail",
            "content": "Renseignez l'URL de base de votre serveur Divalto Infinity, la clé API et les identifiants de l'utilisateur technique."
          }
        ]
      },
      "erpnext": {
        "tip": "ERPNext utilise une authentification par token (API Key + API Secret) disponible directement dans le profil utilisateur Frappe.",
        "steps": [
          {
            "title": "Créer un utilisateur technique",
            "content": "Dans ERPNext, allez dans Paramètres → Utilisateurs → Nouvel utilisateur. Créez un compte dédié (ex. \"api-portail@votreentreprise.com\") avec le rôle \"System Manager\" ou un rôle personnalisé."
          },
          {
            "title": "Générer la clé et le secret API",
            "content": "Ouvrez le profil de l'utilisateur. Dans la section \"API Access\", cliquez sur \"Generate Keys\". Copiez immédiatement l'API Key et l'API Secret — le secret n'est affiché qu'une seule fois."
          },
          {
            "title": "Configurer les permissions de rôle",
            "content": "Dans ERPNext → Paramètres → Gestionnaire de permissions de rôle, assurez-vous que le rôle de l'utilisateur a accès en lecture aux DocTypes : Customer, Sales Invoice, Sales Order, Delivery Note, Item, Issue (Ticket) selon vos besoins."
          },
          {
            "title": "Configurer la connexion dans le portail",
            "content": "Renseignez l'URL de base de votre instance ERPNext (ex. https://monentreprise.erpnext.com), l'API Key et l'API Secret.",
            "code": "https://monentreprise.erpnext.com"
          }
        ]
      },
      "zoho": {
        "tip": "Zoho utilise OAuth 2.0 via Zoho API Console. Les tokens ont une durée de vie limitée et sont automatiquement renouvelés via le refresh token.",
        "steps": [
          {
            "title": "Créer une application dans Zoho API Console",
            "content": "Allez sur api-console.zoho.com → Ajouter un client → \"Server-based Applications\". Renseignez le nom de l'application et l'URL de redirection autorisée. Notez le Client ID et Client Secret."
          },
          {
            "title": "Définir les scopes nécessaires",
            "content": "Lors de la génération du token, incluez les scopes correspondant aux modules utilisés : ZohoCRM.modules.ALL (CRM), ZohoBooks.invoices.READ (Factures), ZohoInventory.invoices.READ (Stock), ZohoDesk.tickets.READ (Support)."
          },
          {
            "title": "Générer le token d'accès OAuth",
            "content": "Dans Zoho API Console, générez un token d'accès et de rafraîchissement pour votre application. Le refresh token est permanent et permet de renouveler l'accès automatiquement."
          },
          {
            "title": "Configurer la connexion dans le portail",
            "content": "Renseignez le Client ID (Clé API), le Client Secret (Secret API) et le Refresh Token. Indiquez également la région Zoho de votre compte (.com, .eu, .in, .com.au)."
          }
        ]
      },
      "cegid": {
        "tip": "Cegid XRP Flex est une solution cloud. L'activation de l'API nécessite généralement une intervention de votre référent Cegid ou revendeur.",
        "steps": [
          {
            "title": "Activer l'accès API avec Cegid",
            "content": "Contactez votre référent Cegid ou votre revendeur pour activer l'accès à l'API REST de Cegid XRP Flex sur votre tenant. Cette étape est généralement réalisée lors de la mise en place."
          },
          {
            "title": "Créer un compte de service",
            "content": "Dans la console d'administration Cegid XRP Flex, créez un compte de service dédié à l'intégration avec les droits de lecture sur les entités nécessaires (Clients, Factures, Commandes, Articles)."
          },
          {
            "title": "Récupérer les identifiants API",
            "content": "Obtenez l'URL de votre tenant Cegid XRP Flex, le Client ID et le Client Secret fournis lors de l'activation API. Ces informations sont disponibles dans le portail d'administration Cegid."
          },
          {
            "title": "Configurer la connexion dans le portail",
            "content": "Renseignez l'URL de base de votre tenant Cegid, la clé API (Client ID) et le secret API (Client Secret). Cliquez sur \"Tester la connexion\" pour valider l'accès."
          }
        ]
      }
    },
    "guides": {
      "users": {
        "tip": "Chaque utilisateur invité reçoit un e-mail avec ses identifiants de connexion. Pensez à vérifier les droits accordés avant la première connexion.",
        "steps": [
          {
            "title": "Accéder à la gestion des utilisateurs",
            "content": "Dans le menu Administration, cliquez sur \"Utilisateurs\" pour afficher la liste des comptes clients actifs."
          },
          {
            "title": "Inviter un nouvel utilisateur",
            "content": "Cliquez sur \"Inviter un utilisateur\", renseignez l'adresse e-mail et sélectionnez les modules auxquels il aura accès (factures, commandes, catalogue, tickets)."
          },
          {
            "title": "Configurer les droits d'accès",
            "content": "Pour chaque module activé, choisissez le niveau d'accès : consultation uniquement ou consultation + actions (ex. passer une commande, créer un ticket)."
          },
          {
            "title": "Désactiver ou supprimer un accès",
            "content": "Depuis la fiche utilisateur, cliquez sur \"Désactiver\" pour suspendre l'accès sans supprimer l'historique, ou \"Supprimer\" pour effacer définitivement le compte."
          }
        ]
      },
      "invoices": {
        "tip": "Les statuts de factures et de commandes sont synchronisés en temps réel depuis votre ERP. En cas d'écart, utilisez le bouton \"Synchroniser\" dans les paramètres.",
        "steps": [
          {
            "title": "Consulter les factures et commandes",
            "content": "Le menu \"Factures & Commandes\" liste tous les documents disponibles. Les données proviennent directement de votre ERP via la connexion configurée."
          },
          {
            "title": "Comprendre les statuts",
            "content": "Chaque document affiche un statut coloré : En attente (gris), En cours (bleu), Payé/Livré (vert), Annulé (rouge). Ces statuts reflètent l'état dans votre ERP."
          },
          {
            "title": "Filtrer et rechercher",
            "content": "Utilisez la barre de recherche et les filtres (date, statut, montant) pour retrouver rapidement un document spécifique."
          },
          {
            "title": "Télécharger un document",
            "content": "Cliquez sur l'icône de téléchargement à droite d'un document pour obtenir le PDF. Cette fonctionnalité nécessite que votre ERP expose les documents en téléchargement."
          }
        ]
      },
      "catalog": {
        "tip": "La synchronisation du catalogue peut prendre quelques minutes après une modification dans votre ERP. Rafraîchissez la page si les nouveaux produits n'apparaissent pas.",
        "steps": [
          {
            "title": "Accéder au catalogue",
            "content": "Le menu \"Catalogue\" affiche les produits et services disponibles, tels qu'ils sont définis dans votre ERP. La disponibilité et les prix reflètent l'état en temps réel."
          },
          {
            "title": "Consulter une fiche produit",
            "content": "Cliquez sur un produit pour afficher ses détails : description, prix unitaire, stock disponible, délai de livraison estimé."
          },
          {
            "title": "Passer une commande",
            "content": "Ajoutez les articles souhaités au panier, vérifiez les quantités, puis cliquez sur \"Valider la commande\". La commande est transmise directement à votre ERP."
          },
          {
            "title": "Suivre une commande",
            "content": "Les commandes passées via le portail apparaissent dans la section \"Factures & Commandes\" avec le statut mis à jour depuis votre ERP."
          }
        ]
      },
      "tickets": {
        "tip": "Les tickets sont visibles de part et d'autre : vos équipes les retrouvent directement dans votre ERP ou outil de support, tandis que le client les suit dans son espace.",
        "steps": [
          {
            "title": "Créer un ticket",
            "content": "Dans le menu \"Support\", cliquez sur \"Nouveau ticket\". Renseignez le sujet, la description du problème et le niveau de priorité. Vous pouvez joindre des fichiers si nécessaire."
          },
          {
            "title": "Suivre l'avancement",
            "content": "La liste des tickets affiche le statut de chaque demande : Ouvert, En cours de traitement, En attente de réponse, Résolu, Fermé."
          },
          {
            "title": "Répondre à un ticket",
            "content": "Ouvrez un ticket existant et utilisez le champ de réponse pour ajouter un message ou des informations complémentaires. Vos équipes en sont notifiées automatiquement."
          },
          {
            "title": "Clore un ticket",
            "content": "Une fois le problème résolu, le ticket peut être fermé par votre équipe ou automatiquement après une période d'inactivité définie dans les paramètres."
          }
        ]
      }
    }
  },
  "notifications": {
    "title": "Notifications",
    "markAllRead": "Tout marquer lu",
    "helpTitle": "Quelles notifications puis-je recevoir ?",
    "helpTypesUser": [
      "Nouvelle facture disponible",
      "Nouveau devis envoyé",
      "Nouveau document partagé",
      "Rappel de paiement (facture échue)",
      "Relance de signature en attente"
    ],
    "helpTypesAdmin": [
      "Nouvelle facture (tous vos clients)",
      "Nouveau devis (tous vos clients)",
      "Nouveau document partagé",
      "Rappel de paiement impayé",
      "Relance de signature en attente"
    ],
    "helpTypesSuperAdmin": [
      "Nouvelle demande d'inscription ERP",
      "Quota dépassé (emails, signatures, IA…)",
      "Crédits faibles sur un compte ERP"
    ]
  },
  "webhookConfig": {
    "sectionTitle": "Webhooks ERP",
    "sectionSubtitle": "Recevez les événements Dolibarr (nouvelles factures, devis, signatures) en temps réel.",
    "urlLabel": "URL du webhook à configurer dans votre ERP",
    "urlHint": "Copiez cette URL entièrement — elle contient la clé secrète. Si vous régénérez, pensez à mettre à jour Dolibarr.",
    "secretLabel": "Clé secrète (incluse dans l'URL)",
    "secretWarning": "La clé est intégrée dans l'URL. Si vous la régénérez, l'ancienne URL ne fonctionnera plus — mettez à jour Dolibarr immédiatement.",
    "reveal": "Afficher",
    "hide": "Masquer",
    "regenerate": "Régénérer la clé",
    "regenerateConfirm": "Régénérer la clé secrète ? L'ancienne clé sera immédiatement invalide et Dolibarr ne pourra plus envoyer de webhooks jusqu'à la mise à jour.",
    "guideTitle": "Configuration dans Dolibarr",
    "guideSteps": [
      "Accueil → Configuration → Modules → rechercher « Webhooks » → activer le module",
      "Accueil → Configuration → Webhooks → cliquer sur l'engrenage du module Webhooks pour ouvrir « Configuration du webhook » → onglet « Cibles » → cliquer sur « + » pour créer une nouvelle cible",
      "Dans le champ « Url », coller l'URL affichée ci-dessus (le token secret est déjà intégré — ne pas le modifier)",
      "Régler le champ « Type » sur « Transaction annuler en cas d'erreur »",
      "Régler le champ « État » sur « Déclenchement automatique »",
      "Dans « Événements déclenchables », cliquer « Ajouter » et saisir les codes de la liste ci-dessous un par un",
      "Enregistrer — les notifications arriveront en temps réel dès le prochain événement",
      "Si Dolibarr affiche une erreur « httpcode=400 » la première fois, consulter votre administrateur système (configuration réseau requise en développement)"
    ],
    "eventsLabel": "Événements déclenchables à configurer :",
    "eventInvoice": "BILL_VALIDATE — nouvelle facture validée → notification client",
    "eventInvoiceModify": "BILL_MODIFY — facture modifiée → notification client",
    "eventProposal": "PROPAL_VALIDATE — devis validé → notification client",
    "eventProposalSent": "PROPAL_SENTBYMAIL — devis envoyé par email → notification client",
    "eventProposalModify": "PROPAL_MODIFY — devis modifié → notification client",
    "eventSigned": "PROPAL_CLOSE_SIGNED — devis accepté → alerte admin",
    "eventRefused": "PROPAL_CLOSE_REFUSED — devis refusé → alerte admin"
  },
  "notifRules": {
    "title": "Règles de notification",
    "subtitle": "Configurez la fréquence des relances automatiques par type de service.",
    "selectErp": "Sélectionner un ERP",
    "chooseErp": "-- Choisir un ERP --",
    "serviceEsignature": "Signature électronique — Relances de signature",
    "serviceInvoice": "Factures — Relances impayés",
    "initialDelay": "Délai initial (après l'événement)",
    "reminderInterval": "Intervalle entre relances",
    "maxReminders": "Nombre max de relances",
    "maxRemindersHint": "0 = illimité",
    "days": "jours",
    "enable": "Activer",
    "disable": "Désactiver",
    "savedOk": "Règle enregistrée.",
    "saveError": "Erreur lors de l'enregistrement.",
    "loadError": "Impossible de charger les règles.",
    "manualTrigger": "Déclencher manuellement",
    "manualTriggerDesc": "Envoie immédiatement les relances de signature en attente selon les règles configurées.",
    "triggerBtn": "Envoyer les relances maintenant",
    "triggerOk": "Relances traitées — envoyées : {{sent}}, ignorées : {{skipped}}, échecs : {{failed}}.",
    "triggerError": "Erreur lors du déclenchement des relances."
  },
  "acceptInvitation": {
    "title": "Créez votre accès",
    "subtitle": "Vous avez été invité(e) par {{company}} (via {{erp}}) à accéder à votre espace client.",
    "proposalHint": "Un devis attend votre signature. Il vous sera présenté après la création de votre compte.",
    "noToken": "Lien d'invitation manquant ou invalide.",
    "invalidToken": "Ce lien d'invitation est expiré ou a déjà été utilisé.",
    "errorTitle": "Lien invalide",
    "passwordHint": "Minimum 8 caractères.",
    "confirmPassword": "Confirmer le mot de passe",
    "passwordTooShort": "Le mot de passe doit contenir au moins 8 caractères.",
    "passwordMismatch": "Les mots de passe ne correspondent pas.",
    "submitBtn": "Créer mon compte",
    "submitError": "Une erreur est survenue. Veuillez réessayer."
  },
  "legal": {
    "nav": {
      "mentions": "Mentions légales",
      "privacy": "Politique de confidentialité",
      "cgu": "Conditions générales d’utilisation",
      "cgv": "Conditions générales de vente"
    }
  }
}
